require=(function(){function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s}return e})()({1:[function(require,module,exports){
(function (process,global){
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.4+314e4831
 */

(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global.ES6Promise = factory());
}(this, (function () { 'use strict';

function objectOrFunction(x) {
  var type = typeof x;
  return x !== null && (type === 'object' || type === 'function');
}

function isFunction(x) {
  return typeof x === 'function';
}



var _isArray = void 0;
if (Array.isArray) {
  _isArray = Array.isArray;
} else {
  _isArray = function (x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  };
}

var isArray = _isArray;

var len = 0;
var vertxNext = void 0;
var customSchedulerFn = void 0;

var asap = function asap(callback, arg) {
  queue[len] = callback;
  queue[len + 1] = arg;
  len += 2;
  if (len === 2) {
    // If len is 2, that means that we need to schedule an async flush.
    // If additional callbacks are queued before the queue is flushed, they
    // will be processed by this flush that we are scheduling.
    if (customSchedulerFn) {
      customSchedulerFn(flush);
    } else {
      scheduleFlush();
    }
  }
};

function setScheduler(scheduleFn) {
  customSchedulerFn = scheduleFn;
}

function setAsap(asapFn) {
  asap = asapFn;
}

var browserWindow = typeof window !== 'undefined' ? window : undefined;
var browserGlobal = browserWindow || {};
var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

// test for web worker but not in IE10
var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

// node
function useNextTick() {
  // node version 0.10.x displays a deprecation warning when nextTick is used recursively
  // see https://github.com/cujojs/when/issues/410 for details
  return function () {
    return process.nextTick(flush);
  };
}

// vertx
function useVertxTimer() {
  if (typeof vertxNext !== 'undefined') {
    return function () {
      vertxNext(flush);
    };
  }

  return useSetTimeout();
}

function useMutationObserver() {
  var iterations = 0;
  var observer = new BrowserMutationObserver(flush);
  var node = document.createTextNode('');
  observer.observe(node, { characterData: true });

  return function () {
    node.data = iterations = ++iterations % 2;
  };
}

// web worker
function useMessageChannel() {
  var channel = new MessageChannel();
  channel.port1.onmessage = flush;
  return function () {
    return channel.port2.postMessage(0);
  };
}

function useSetTimeout() {
  // Store setTimeout reference so es6-promise will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var globalSetTimeout = setTimeout;
  return function () {
    return globalSetTimeout(flush, 1);
  };
}

var queue = new Array(1000);
function flush() {
  for (var i = 0; i < len; i += 2) {
    var callback = queue[i];
    var arg = queue[i + 1];

    callback(arg);

    queue[i] = undefined;
    queue[i + 1] = undefined;
  }

  len = 0;
}

function attemptVertx() {
  try {
    var vertx = Function('return this')().require('vertx');
    vertxNext = vertx.runOnLoop || vertx.runOnContext;
    return useVertxTimer();
  } catch (e) {
    return useSetTimeout();
  }
}

var scheduleFlush = void 0;
// Decide what async method to use to triggering processing of queued callbacks:
if (isNode) {
  scheduleFlush = useNextTick();
} else if (BrowserMutationObserver) {
  scheduleFlush = useMutationObserver();
} else if (isWorker) {
  scheduleFlush = useMessageChannel();
} else if (browserWindow === undefined && typeof require === 'function') {
  scheduleFlush = attemptVertx();
} else {
  scheduleFlush = useSetTimeout();
}

function then(onFulfillment, onRejection) {
  var parent = this;

  var child = new this.constructor(noop);

  if (child[PROMISE_ID] === undefined) {
    makePromise(child);
  }

  var _state = parent._state;


  if (_state) {
    var callback = arguments[_state - 1];
    asap(function () {
      return invokeCallback(_state, child, callback, parent._result);
    });
  } else {
    subscribe(parent, child, onFulfillment, onRejection);
  }

  return child;
}

/**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/
function resolve$1(object) {
  /*jshint validthis:true */
  var Constructor = this;

  if (object && typeof object === 'object' && object.constructor === Constructor) {
    return object;
  }

  var promise = new Constructor(noop);
  resolve(promise, object);
  return promise;
}

var PROMISE_ID = Math.random().toString(36).substring(2);

function noop() {}

var PENDING = void 0;
var FULFILLED = 1;
var REJECTED = 2;

var TRY_CATCH_ERROR = { error: null };

function selfFulfillment() {
  return new TypeError("You cannot resolve a promise with itself");
}

function cannotReturnOwn() {
  return new TypeError('A promises callback cannot return that same promise.');
}

function getThen(promise) {
  try {
    return promise.then;
  } catch (error) {
    TRY_CATCH_ERROR.error = error;
    return TRY_CATCH_ERROR;
  }
}

function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
  try {
    then$$1.call(value, fulfillmentHandler, rejectionHandler);
  } catch (e) {
    return e;
  }
}

function handleForeignThenable(promise, thenable, then$$1) {
  asap(function (promise) {
    var sealed = false;
    var error = tryThen(then$$1, thenable, function (value) {
      if (sealed) {
        return;
      }
      sealed = true;
      if (thenable !== value) {
        resolve(promise, value);
      } else {
        fulfill(promise, value);
      }
    }, function (reason) {
      if (sealed) {
        return;
      }
      sealed = true;

      reject(promise, reason);
    }, 'Settle: ' + (promise._label || ' unknown promise'));

    if (!sealed && error) {
      sealed = true;
      reject(promise, error);
    }
  }, promise);
}

function handleOwnThenable(promise, thenable) {
  if (thenable._state === FULFILLED) {
    fulfill(promise, thenable._result);
  } else if (thenable._state === REJECTED) {
    reject(promise, thenable._result);
  } else {
    subscribe(thenable, undefined, function (value) {
      return resolve(promise, value);
    }, function (reason) {
      return reject(promise, reason);
    });
  }
}

function handleMaybeThenable(promise, maybeThenable, then$$1) {
  if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
    handleOwnThenable(promise, maybeThenable);
  } else {
    if (then$$1 === TRY_CATCH_ERROR) {
      reject(promise, TRY_CATCH_ERROR.error);
      TRY_CATCH_ERROR.error = null;
    } else if (then$$1 === undefined) {
      fulfill(promise, maybeThenable);
    } else if (isFunction(then$$1)) {
      handleForeignThenable(promise, maybeThenable, then$$1);
    } else {
      fulfill(promise, maybeThenable);
    }
  }
}

function resolve(promise, value) {
  if (promise === value) {
    reject(promise, selfFulfillment());
  } else if (objectOrFunction(value)) {
    handleMaybeThenable(promise, value, getThen(value));
  } else {
    fulfill(promise, value);
  }
}

function publishRejection(promise) {
  if (promise._onerror) {
    promise._onerror(promise._result);
  }

  publish(promise);
}

function fulfill(promise, value) {
  if (promise._state !== PENDING) {
    return;
  }

  promise._result = value;
  promise._state = FULFILLED;

  if (promise._subscribers.length !== 0) {
    asap(publish, promise);
  }
}

function reject(promise, reason) {
  if (promise._state !== PENDING) {
    return;
  }
  promise._state = REJECTED;
  promise._result = reason;

  asap(publishRejection, promise);
}

function subscribe(parent, child, onFulfillment, onRejection) {
  var _subscribers = parent._subscribers;
  var length = _subscribers.length;


  parent._onerror = null;

  _subscribers[length] = child;
  _subscribers[length + FULFILLED] = onFulfillment;
  _subscribers[length + REJECTED] = onRejection;

  if (length === 0 && parent._state) {
    asap(publish, parent);
  }
}

function publish(promise) {
  var subscribers = promise._subscribers;
  var settled = promise._state;

  if (subscribers.length === 0) {
    return;
  }

  var child = void 0,
      callback = void 0,
      detail = promise._result;

  for (var i = 0; i < subscribers.length; i += 3) {
    child = subscribers[i];
    callback = subscribers[i + settled];

    if (child) {
      invokeCallback(settled, child, callback, detail);
    } else {
      callback(detail);
    }
  }

  promise._subscribers.length = 0;
}

function tryCatch(callback, detail) {
  try {
    return callback(detail);
  } catch (e) {
    TRY_CATCH_ERROR.error = e;
    return TRY_CATCH_ERROR;
  }
}

function invokeCallback(settled, promise, callback, detail) {
  var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = void 0,
      failed = void 0;

  if (hasCallback) {
    value = tryCatch(callback, detail);

    if (value === TRY_CATCH_ERROR) {
      failed = true;
      error = value.error;
      value.error = null;
    } else {
      succeeded = true;
    }

    if (promise === value) {
      reject(promise, cannotReturnOwn());
      return;
    }
  } else {
    value = detail;
    succeeded = true;
  }

  if (promise._state !== PENDING) {
    // noop
  } else if (hasCallback && succeeded) {
    resolve(promise, value);
  } else if (failed) {
    reject(promise, error);
  } else if (settled === FULFILLED) {
    fulfill(promise, value);
  } else if (settled === REJECTED) {
    reject(promise, value);
  }
}

function initializePromise(promise, resolver) {
  try {
    resolver(function resolvePromise(value) {
      resolve(promise, value);
    }, function rejectPromise(reason) {
      reject(promise, reason);
    });
  } catch (e) {
    reject(promise, e);
  }
}

var id = 0;
function nextId() {
  return id++;
}

function makePromise(promise) {
  promise[PROMISE_ID] = id++;
  promise._state = undefined;
  promise._result = undefined;
  promise._subscribers = [];
}

function validationError() {
  return new Error('Array Methods must be provided an Array');
}

var Enumerator = function () {
  function Enumerator(Constructor, input) {
    this._instanceConstructor = Constructor;
    this.promise = new Constructor(noop);

    if (!this.promise[PROMISE_ID]) {
      makePromise(this.promise);
    }

    if (isArray(input)) {
      this.length = input.length;
      this._remaining = input.length;

      this._result = new Array(this.length);

      if (this.length === 0) {
        fulfill(this.promise, this._result);
      } else {
        this.length = this.length || 0;
        this._enumerate(input);
        if (this._remaining === 0) {
          fulfill(this.promise, this._result);
        }
      }
    } else {
      reject(this.promise, validationError());
    }
  }

  Enumerator.prototype._enumerate = function _enumerate(input) {
    for (var i = 0; this._state === PENDING && i < input.length; i++) {
      this._eachEntry(input[i], i);
    }
  };

  Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
    var c = this._instanceConstructor;
    var resolve$$1 = c.resolve;


    if (resolve$$1 === resolve$1) {
      var _then = getThen(entry);

      if (_then === then && entry._state !== PENDING) {
        this._settledAt(entry._state, i, entry._result);
      } else if (typeof _then !== 'function') {
        this._remaining--;
        this._result[i] = entry;
      } else if (c === Promise$1) {
        var promise = new c(noop);
        handleMaybeThenable(promise, entry, _then);
        this._willSettleAt(promise, i);
      } else {
        this._willSettleAt(new c(function (resolve$$1) {
          return resolve$$1(entry);
        }), i);
      }
    } else {
      this._willSettleAt(resolve$$1(entry), i);
    }
  };

  Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
    var promise = this.promise;


    if (promise._state === PENDING) {
      this._remaining--;

      if (state === REJECTED) {
        reject(promise, value);
      } else {
        this._result[i] = value;
      }
    }

    if (this._remaining === 0) {
      fulfill(promise, this._result);
    }
  };

  Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
    var enumerator = this;

    subscribe(promise, undefined, function (value) {
      return enumerator._settledAt(FULFILLED, i, value);
    }, function (reason) {
      return enumerator._settledAt(REJECTED, i, reason);
    });
  };

  return Enumerator;
}();

/**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/
function all(entries) {
  return new Enumerator(this, entries).promise;
}

/**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/
function race(entries) {
  /*jshint validthis:true */
  var Constructor = this;

  if (!isArray(entries)) {
    return new Constructor(function (_, reject) {
      return reject(new TypeError('You must pass an array to race.'));
    });
  } else {
    return new Constructor(function (resolve, reject) {
      var length = entries.length;
      for (var i = 0; i < length; i++) {
        Constructor.resolve(entries[i]).then(resolve, reject);
      }
    });
  }
}

/**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/
function reject$1(reason) {
  /*jshint validthis:true */
  var Constructor = this;
  var promise = new Constructor(noop);
  reject(promise, reason);
  return promise;
}

function needsResolver() {
  throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
}

function needsNew() {
  throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
}

/**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/

var Promise$1 = function () {
  function Promise(resolver) {
    this[PROMISE_ID] = nextId();
    this._result = this._state = undefined;
    this._subscribers = [];

    if (noop !== resolver) {
      typeof resolver !== 'function' && needsResolver();
      this instanceof Promise ? initializePromise(this, resolver) : needsNew();
    }
  }

  /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */

  /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */


  Promise.prototype.catch = function _catch(onRejection) {
    return this.then(null, onRejection);
  };

  /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */


  Promise.prototype.finally = function _finally(callback) {
    var promise = this;
    var constructor = promise.constructor;

    return promise.then(function (value) {
      return constructor.resolve(callback()).then(function () {
        return value;
      });
    }, function (reason) {
      return constructor.resolve(callback()).then(function () {
        throw reason;
      });
    });
  };

  return Promise;
}();

Promise$1.prototype.then = then;
Promise$1.all = all;
Promise$1.race = race;
Promise$1.resolve = resolve$1;
Promise$1.reject = reject$1;
Promise$1._setScheduler = setScheduler;
Promise$1._setAsap = setAsap;
Promise$1._asap = asap;

/*global self*/
function polyfill() {
  var local = void 0;

  if (typeof global !== 'undefined') {
    local = global;
  } else if (typeof self !== 'undefined') {
    local = self;
  } else {
    try {
      local = Function('return this')();
    } catch (e) {
      throw new Error('polyfill failed because global object is unavailable in this environment');
    }
  }

  var P = local.Promise;

  if (P) {
    var promiseToString = null;
    try {
      promiseToString = Object.prototype.toString.call(P.resolve());
    } catch (e) {
      // silently ignored
    }

    if (promiseToString === '[object Promise]' && !P.cast) {
      return;
    }
  }

  local.Promise = Promise$1;
}

// Strange compat..
Promise$1.polyfill = polyfill;
Promise$1.Promise = Promise$1;

return Promise$1;

})));





}).call(this,require('_process'),typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"_process":2}],2:[function(require,module,exports){
// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };

},{}],3:[function(require,module,exports){
(function (global){
//     Underscore.js 1.9.0
//     http://underscorejs.org
//     (c) 2009-2018 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` (`self`) in the browser, `global`
  // on the server, or `this` in some virtual machines. We use `self`
  // instead of `window` for `WebWorker` support.
  var root = typeof self == 'object' && self.self === self && self ||
            typeof global == 'object' && global.global === global && global ||
            this ||
            {};

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype;
  var SymbolProto = typeof Symbol !== 'undefined' ? Symbol.prototype : null;

  // Create quick reference variables for speed access to core prototypes.
  var push = ArrayProto.push,
      slice = ArrayProto.slice,
      toString = ObjProto.toString,
      hasOwnProperty = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var nativeIsArray = Array.isArray,
      nativeKeys = Object.keys,
      nativeCreate = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for their old module API. If we're in
  // the browser, add `_` as a global object.
  // (`nodeType` is checked to ensure that `module`
  // and `exports` are not HTML elements.)
  if (typeof exports != 'undefined' && !exports.nodeType) {
    if (typeof module != 'undefined' && !module.nodeType && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.9.0';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      // The 2-argument case is omitted because we’re not using it.
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  var builtinIteratee;

  // An internal function to generate callbacks that can be applied to each
  // element in a collection, returning the desired result — either `identity`,
  // an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (_.iteratee !== builtinIteratee) return _.iteratee(value, context);
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value) && !_.isArray(value)) return _.matcher(value);
    return _.property(value);
  };

  // External wrapper for our callback generator. Users may customize
  // `_.iteratee` if they want additional predicate/iteratee shorthand styles.
  // This abstraction hides the internal-only argCount argument.
  _.iteratee = builtinIteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // Some functions take a variable number of arguments, or a few expected
  // arguments at the beginning and then a variable number of values to operate
  // on. This helper accumulates all remaining arguments past the function’s
  // argument length (or an explicit `startIndex`), into an array that becomes
  // the last argument. Similar to ES6’s "rest parameter".
  var restArguments = function(func, startIndex) {
    startIndex = startIndex == null ? func.length - 1 : +startIndex;
    return function() {
      var length = Math.max(arguments.length - startIndex, 0),
          rest = Array(length),
          index = 0;
      for (; index < length; index++) {
        rest[index] = arguments[index + startIndex];
      }
      switch (startIndex) {
        case 0: return func.call(this, rest);
        case 1: return func.call(this, arguments[0], rest);
        case 2: return func.call(this, arguments[0], arguments[1], rest);
      }
      var args = Array(startIndex + 1);
      for (index = 0; index < startIndex; index++) {
        args[index] = arguments[index];
      }
      args[startIndex] = rest;
      return func.apply(this, args);
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var shallowProperty = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  var deepGet = function(obj, path) {
    var length = path.length;
    for (var i = 0; i < length; i++) {
      if (obj == null) return void 0;
      obj = obj[path[i]];
    }
    return length ? obj : void 0;
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object.
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = shallowProperty('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  var createReduce = function(dir) {
    // Wrap code that reassigns argument variables in a separate function than
    // the one that accesses `arguments.length` to avoid a perf hit. (#1991)
    var reducer = function(obj, iteratee, memo, initial) {
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      if (!initial) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    };

    return function(obj, iteratee, memo, context) {
      var initial = arguments.length >= 3;
      return reducer(obj, optimizeCb(iteratee, context, 4), memo, initial);
    };
  };

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var keyFinder = isArrayLike(obj) ? _.findIndex : _.findKey;
    var key = keyFinder(obj, predicate, context);
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = restArguments(function(obj, path, args) {
    var contextPath, func;
    if (_.isFunction(path)) {
      func = path;
    } else if (_.isArray(path)) {
      contextPath = path.slice(0, -1);
      path = path[path.length - 1];
    }
    return _.map(obj, function(context) {
      var method = func;
      if (!method) {
        if (contextPath && contextPath.length) {
          context = deepGet(context, contextPath);
        }
        if (context == null) return void 0;
        method = context[path];
      }
      return method == null ? method : method.apply(context, args);
    });
  });

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null || typeof iteratee == 'number' && typeof obj[0] != 'object' && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value != null && value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(v, index, list) {
        computed = iteratee(v, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = v;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection.
  _.shuffle = function(obj) {
    return _.sample(obj, Infinity);
  };

  // Sample **n** random values from a collection using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    var sample = isArrayLike(obj) ? _.clone(obj) : _.values(obj);
    var length = getLength(sample);
    n = Math.max(Math.min(n, length), 0);
    var last = length - 1;
    for (var index = 0; index < n; index++) {
      var rand = _.random(index, last);
      var temp = sample[index];
      sample[index] = sample[rand];
      sample[rand] = temp;
    }
    return sample.slice(0, n);
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    var index = 0;
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, key, list) {
      return {
        value: value,
        index: index++,
        criteria: iteratee(value, key, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior, partition) {
    return function(obj, iteratee, context) {
      var result = partition ? [[], []] : {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  var reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (_.isString(obj)) {
      // Keep surrogate pair characters together
      return obj.match(reStrSymbol);
    }
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = group(function(result, value, pass) {
    result[pass ? 0 : 1].push(value);
  }, true);

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null || array.length < 1) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null || array.length < 1) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, Boolean);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, output) {
    output = output || [];
    var idx = output.length;
    for (var i = 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        // Flatten current level of array or arguments object.
        if (shallow) {
          var j = 0, len = value.length;
          while (j < len) output[idx++] = value[j++];
        } else {
          flatten(value, shallow, strict, output);
          idx = output.length;
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = restArguments(function(array, otherArrays) {
    return _.difference(array, otherArrays);
  });

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // The faster algorithm will not work with an iteratee if the iteratee
  // is not a one-to-one function, so providing an iteratee will disable
  // the faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted && !iteratee) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = restArguments(function(arrays) {
    return _.uniq(flatten(arrays, true, true));
  });

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      var j;
      for (j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = restArguments(function(array, rest) {
    rest = flatten(rest, true, true);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  });

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices.
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = restArguments(_.unzip);

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values. Passing by pairs is the reverse of _.pairs.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions.
  var createPredicateIndexFinder = function(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  };

  // Returns the first index on an array-like that passes a predicate test.
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions.
  var createIndexFinder = function(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
          i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
          length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  };

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    if (!step) {
      step = stop < start ? -1 : 1;
    }

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Chunk a single array into multiple arrays, each containing `count` or fewer
  // items.
  _.chunk = function(array, count) {
    if (count == null || count < 1) return [];
    var result = [];
    var i = 0, length = array.length;
    while (i < length) {
      result.push(slice.call(array, i, i += count));
    }
    return result;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments.
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = restArguments(function(func, context, args) {
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var bound = restArguments(function(callArgs) {
      return executeBound(func, bound, context, this, args.concat(callArgs));
    });
    return bound;
  });

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder by default, allowing any combination of arguments to be
  // pre-filled. Set `_.partial.placeholder` for a custom placeholder argument.
  _.partial = restArguments(function(func, boundArgs) {
    var placeholder = _.partial.placeholder;
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === placeholder ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  });

  _.partial.placeholder = _;

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = restArguments(function(obj, keys) {
    keys = flatten(keys, false, false);
    var index = keys.length;
    if (index < 1) throw new Error('bindAll must be passed function names');
    while (index--) {
      var key = keys[index];
      obj[key] = _.bind(obj[key], obj);
    }
  });

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = restArguments(function(func, wait, args) {
    return setTimeout(function() {
      return func.apply(null, args);
    }, wait);
  });

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var timeout, context, args, result;
    var previous = 0;
    if (!options) options = {};

    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var throttled = function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };

    throttled.cancel = function() {
      clearTimeout(timeout);
      previous = 0;
      timeout = context = args = null;
    };

    return throttled;
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, result;

    var later = function(context, args) {
      timeout = null;
      if (args) result = func.apply(context, args);
    };

    var debounced = restArguments(function(args) {
      if (timeout) clearTimeout(timeout);
      if (immediate) {
        var callNow = !timeout;
        timeout = setTimeout(later, wait);
        if (callNow) result = func.apply(this, args);
      } else {
        timeout = _.delay(later, wait, this, args);
      }

      return result;
    });

    debounced.cancel = function() {
      clearTimeout(timeout);
      timeout = null;
    };

    return debounced;
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  _.restArguments = restArguments;

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
    'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  var collectNonEnumProps = function(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = _.isFunction(constructor) && constructor.prototype || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  };

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`.
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object.
  // In contrast to _.map it returns an object.
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = _.keys(obj),
        length = keys.length,
        results = {};
    for (var index = 0; index < length; index++) {
      var currentKey = keys[index];
      results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  // The opposite of _.object.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`.
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, defaults) {
    return function(obj) {
      var length = arguments.length;
      if (defaults) obj = Object(obj);
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!defaults || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s).
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test.
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Internal pick helper function to determine if `obj` has key `key`.
  var keyInObj = function(value, key, obj) {
    return key in obj;
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = restArguments(function(obj, keys) {
    var result = {}, iteratee = keys[0];
    if (obj == null) return result;
    if (_.isFunction(iteratee)) {
      if (keys.length > 1) iteratee = optimizeCb(iteratee, keys[1]);
      keys = _.allKeys(obj);
    } else {
      iteratee = keyInObj;
      keys = flatten(keys, false, false);
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  });

  // Return a copy of the object without the blacklisted properties.
  _.omit = restArguments(function(obj, keys) {
    var iteratee = keys[0], context;
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
      if (keys.length > 1) context = keys[1];
    } else {
      keys = _.map(flatten(keys, false, false), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  });

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq, deepEq;
  eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // `null` or `undefined` only equal to itself (strict comparison).
    if (a == null || b == null) return false;
    // `NaN`s are equivalent, but non-reflexive.
    if (a !== a) return b !== b;
    // Exhaust primitive checks
    var type = typeof a;
    if (type !== 'function' && type !== 'object' && typeof b != 'object') return false;
    return deepEq(a, b, aStack, bStack);
  };

  // Internal recursive comparison function for `isEqual`.
  deepEq = function(a, b, aStack, bStack) {
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN.
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
      case '[object Symbol]':
        return SymbolProto.valueOf.call(a) === SymbolProto.valueOf.call(b);
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError, isMap, isWeakMap, isSet, isWeakSet.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error', 'Symbol', 'Map', 'WeakMap', 'Set', 'WeakSet'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), Safari 8 (#1929), and PhantomJS (#2236).
  var nodelist = root.document && root.document.childNodes;
  if (typeof /./ != 'function' && typeof Int8Array != 'object' && typeof nodelist != 'function') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return !_.isSymbol(obj) && isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`?
  _.isNaN = function(obj) {
    return _.isNumber(obj) && isNaN(obj);
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, path) {
    if (!_.isArray(path)) {
      return obj != null && hasOwnProperty.call(obj, path);
    }
    var length = path.length;
    for (var i = 0; i < length; i++) {
      var key = path[i];
      if (obj == null || !hasOwnProperty.call(obj, key)) {
        return false;
      }
      obj = obj[key];
    }
    return !!length;
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  // Creates a function that, when passed an object, will traverse that object’s
  // properties down the given `path`, specified as an array of keys or indexes.
  _.property = function(path) {
    if (!_.isArray(path)) {
      return shallowProperty(path);
    }
    return function(obj) {
      return deepGet(obj, path);
    };
  };

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    if (obj == null) {
      return function(){};
    }
    return function(path) {
      return !_.isArray(path) ? obj[path] : deepGet(obj, path);
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

  // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // Traverses the children of `obj` along `path`. If a child is a function, it
  // is invoked with its parent as context. Returns the value of the final
  // child, or `fallback` if any child is undefined.
  _.result = function(obj, path, fallback) {
    if (!_.isArray(path)) path = [path];
    var length = path.length;
    if (!length) {
      return _.isFunction(fallback) ? fallback.call(obj) : fallback;
    }
    for (var i = 0; i < length; i++) {
      var prop = obj == null ? void 0 : obj[path[i]];
      if (prop === void 0) {
        prop = fallback;
        i = length; // Ensure we don't continue iterating.
      }
      obj = _.isFunction(prop) ? prop.call(obj) : prop;
    }
    return obj;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate: /<%([\s\S]+?)%>/g,
    interpolate: /<%=([\s\S]+?)%>/g,
    escape: /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'": "'",
    '\\': '\\',
    '\r': 'r',
    '\n': 'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escapeRegExp, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offset.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    var render;
    try {
      render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var chainResult = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return chainResult(this, func.apply(_, args));
      };
    });
    return _;
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return chainResult(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return chainResult(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return String(this._wrapped);
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (typeof define == 'function' && define.amd) {
    define('underscore', [], function() {
      return _;
    });
  }
}());

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],4:[function(require,module,exports){
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */
var byteToHex = [];
for (var i = 0; i < 256; ++i) {
  byteToHex[i] = (i + 0x100).toString(16).substr(1);
}

function bytesToUuid(buf, offset) {
  var i = offset || 0;
  var bth = byteToHex;
  return bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] + '-' +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]] +
          bth[buf[i++]] + bth[buf[i++]];
}

module.exports = bytesToUuid;

},{}],5:[function(require,module,exports){
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection

// getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
var getRandomValues = (typeof(crypto) != 'undefined' && crypto.getRandomValues.bind(crypto)) ||
                      (typeof(msCrypto) != 'undefined' && msCrypto.getRandomValues.bind(msCrypto));
if (getRandomValues) {
  // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
  var rnds8 = new Uint8Array(16); // eslint-disable-line no-undef

  module.exports = function whatwgRNG() {
    getRandomValues(rnds8);
    return rnds8;
  };
} else {
  // Math.random()-based (RNG)
  //
  // If all else fails, use Math.random().  It's fast, but is of unspecified
  // quality.
  var rnds = new Array(16);

  module.exports = function mathRNG() {
    for (var i = 0, r; i < 16; i++) {
      if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
      rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
    }

    return rnds;
  };
}

},{}],6:[function(require,module,exports){
var rng = require('./lib/rng');
var bytesToUuid = require('./lib/bytesToUuid');

function v4(options, buf, offset) {
  var i = buf && offset || 0;

  if (typeof(options) == 'string') {
    buf = options === 'binary' ? new Array(16) : null;
    options = null;
  }
  options = options || {};

  var rnds = options.random || (options.rng || rng)();

  // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
  rnds[6] = (rnds[6] & 0x0f) | 0x40;
  rnds[8] = (rnds[8] & 0x3f) | 0x80;

  // Copy bytes to buffer, if provided
  if (buf) {
    for (var ii = 0; ii < 16; ++ii) {
      buf[i + ii] = rnds[ii];
    }
  }

  return buf || bytesToUuid(rnds);
}

module.exports = v4;

},{"./lib/bytesToUuid":4,"./lib/rng":5}],7:[function(require,module,exports){
'use strict';

var _ = require('underscore');

var Elem = require('./elem');
var Region = require('./region');
var logger = require('./logger');

var ProtoState = function (name) {
    Elem.call(this, name);

    this._type = 'state';
    this.container = null;
    this.region = null;

    this.children = [];

    this.setObserverType('container');
};

ProtoState.prototype = _.create(Elem.prototype, {
    constructor: ProtoState,

    _cname: 'ProtoState',

    getRegion: function (index) {
        var result;
        if (_.isNumber(index)) {
            result = this.children[index];

        } else {
            result = this.region;
        }

        return result;
    },

    getRegionByName: function (regionName) {
        return _.find(this.children, function (region) {
            return region.getName() === regionName;
        });
    },

    getRegionById: function (regionId) {
        return _.find(this.children, function (region) {
            return region.getId() === regionId;
        });
    },

    filterActiveRegion: function () {
        return _.filter(this.children, function (region) {
            return region.isActive();
        });
    },

    completion: function () {
        if (!this.isActive()) {
            logger.error(this._cname + 'インスタンス"' + this._name + '"はすでに非アクティブ化されています。');
        }

        this._async(function () {
            this._exit();

            if (!_.isNull(this.container)) {
                this.notify('container', 'completion');
            }
        });
    },

    _getParentState: function () {
        var result = null;
        if (!_.isNull(this.container) && !_.isNull(this.container.parent)) {
            result = this.container.parent;
        }

        return result;
    },

    _hasSubState: function () {
        var result = _.some(this.children, function (region) {
            return region.children.states.length > 0;
        });

        return result;
    },

    update: function (event) {
        var params = _.toArray(arguments).slice(1);

        switch (event) {
            case 'entry':
                this._entry.apply(this, params);
                break;

            case 'exit':
                this._exit.apply(this, params);
                break;

            case 'refresh':
                this._refresh.apply(this, params);
                break;

            case 'completion':
                this.completion.apply(this, params);
                break;
        }
    },

    _refresh: function (depth) {
        this._depth = depth;
        this.parent = this._getParentState();
        this.notify('children', 'refresh', depth);
    },

    _entry: function (message) {
        if (!this.isActive()) {
            this._activate();
            this.notify('children', 'entry', message);
        }
    },

    addState: function () {
        var states = _.toArray(arguments);
        if (_.isNull(this.region)) {
            this.appendRegion();
        }

        return this.region.addState.apply(this.region, states);
    },

    removeState: function () {
        var states = _.toArray(arguments);
        if (_.isNull(this.region)) {
            logger.error('デフォルトのRegionインスタンスが存在しません。');
        }

        return this.region.removeState.apply(this.region, states);
    },

    addTransition: function () {
        var transits = _.toArray(arguments);
        if (_.isNull(this.region)) {
            this.appendRegion();
        }

        return this.region.addTransition.apply(this.region, transits);
    },

    removeTransition: function () {
        var transits = _.toArray(arguments);
        if (_.isNull(this.region)) {
            logger.error('デフォルトのRegionインスタンスが存在しません。');
        }

        return this.region.removeTransition.apply(this.region, transits);
    },

    appendRegion: function (region) {
        if (this._attached) {
            logger.error('デプロイ後は要素の追加/削除はできません。Machineクラスのundeploy()メソッドでデプロイを取り消してください。');
        }

        if (_.isNull(this.region)) {
            if (_.isUndefined(region)) {
                region = new Region('default-region-of-' + this._name);
                logger.info(this._cname + 'インスタンス"' + this._name + '"のRegionインスタンスが自動作成されました。');

            } else if (!(region instanceof Region)) {
                logger.error('Regionインスタンスを指定してください。');
            }

            this.region = region;
        } else {
            if (_.isUndefined(region)) {
                region = new Region(false);

            } else if (!(region instanceof Region)) {
                logger.error('Regionインスタンスを指定してください。');
            }
        }

        region.parent = this;
        this.children.push(region);

        this.addObserver('children', region);
        region.addObserver('parent', this);

        if (!region._originalName) {
            region.setName('region-index-' + region.getIndex() + '-of-' + this._name, true);
            region._setDefaultStateName();
        }

        region._refresh(this._depth);

        return region;
    },

    removeRegion: function (region) {
        var index;
        if (this._attached) {
            logger.error('デプロイ後は要素の追加/削除はできません。Machineクラスのundeploy()メソッドでデプロイを取り消してください。');
        }

        if (!(region instanceof Region)) {
            logger.error('Regionインスタンスを指定してください。');
        }

        index = _.indexOf(this.children, region);
        if (index > -1) {
            this.children.splice(index, 1);

        } else {
            logger.error('削除対象のRegionインスタンスが見つかりません。');
        }

        region.parent = null;

        if (this.region === region) {
            this.region = null;
        }

        region._refresh();

        this.removeObserver('children', region);
        region.removeObserver('parent', this);

        if (!region._originalName) {
            region.setName(region.getId(), true);
            region._setDefaultStateName();
        }

        return region;
    },
});

module.exports = ProtoState;

},{"./elem":8,"./logger":10,"./region":16,"underscore":3}],8:[function(require,module,exports){
'use strict';

var Promise = require('es6-promise').Promise;
var _ = require('underscore');

var Entity = require('./entity');
var mixin = require('./mixin');

var Elem = function (name) {
    Entity.call(this, name);

    this._type = 'element';

    this.root = null;
    this.parent = null;
    this.children = null;
    this._attached = false;
    this._depth = 0;

    this.setObserverType('root', 'parent', 'children');

    Object.defineProperties(this, mixin.descriptor);
};

Elem.prototype = _.create(Entity.prototype, _.extend({
    constructor: Elem,

    _cname: 'Elem',

    getCurrentDepth: function () {
        return this._depth;
    },

    _async: function (callback) {
        callback = _.bind(callback, this);
        this.notify('root', 'async', function () {
            callback();
            return Promise.resolve();
        });
    },

    _entry: function () {
        if (!this.isActive()) {
            this._activate();
            this.notify('children', 'entry');
        }
    },

    _exit: function () {
        if (this.isActive()) {
            this.notify('children', 'exit');
            this._deactivate();
        }
    },
}, mixin.helper));

module.exports = Elem;

},{"./entity":9,"./mixin":12,"es6-promise":1,"underscore":3}],9:[function(require,module,exports){
'use strict';

var uuidv4 = require('uuid/v4');
var _ = require('underscore');

var Subject = require('./subject');
var Model = require('./model');
var logger = require('./logger');
var util = require('./util');
var mixin = require('./mixin');

var Entity = function (name) {
    Subject.call(this);

    this._id = uuidv4();

    if (!util.isFalsy(name)) {
        this._name = this._originalName = name;

    } else {
        this._name = this._id;
        this._originalName = false;
    }

    this._type = 'entity';
    this._status = 'inactive';

    this.model = new Model();
};

Entity.prototype = _.create(Subject.prototype, _.extend({
    constructor: Entity,

    _cname: 'Entity',

    getId: function () {
        return this._id;
    },

    getName: function () {
        return this._name;
    },

    setName: function (name, automatical) {
        this._name = name;
        if (!this._originalName && util.isFalsy(automatical)) {
            this._originalName = name;
        }

        return name;
    },

    isActive: function () {
        return this._status === 'active';
    },

    _activate: function () {
        if (!this.isActive()) {
            this._status = 'active';
            logger.info(this._cname + 'インスタンス"' + this._name + '"がアクティブ化されました。');
        }
    },

    _deactivate: function () {
        if (this.isActive()) {
            this._status = 'inactive';
            logger.info(this._cname + 'インスタンス"' + this._name + '"が非アクティブ化されました。');
        }
    },

    update: _.noop,

}, mixin.accessor));

module.exports = Entity;

},{"./logger":10,"./mixin":12,"./model":13,"./subject":18,"./util":20,"underscore":3,"uuid/v4":6}],10:[function(require,module,exports){
'use strict';

var _ = require('underscore');

var logger = {
    config: {
        logLevel: 'DEBUG',
        debuggable: true,
    },

    logLevelData: [
        'DEBUG',
        'INFO',
        'WARN',
        'ERROR',
    ],

    enable: function () {
        if (!this.config.debuggable) {
            this.config.debuggable = true;
        }
    },

    disable: function () {
        if (this.config.debuggable) {
            this.config.debuggable = false;
        }
    },

    setLogLevel: function (level) {
        level = level.toUpperCase();
        if (_.indexOf(this.logLevelData, level) !== -1) {
            this.config.logLevel = level;
        }
    },

    debug: function (message) {
        if (this.config.debuggable && _.indexOf(this.logLevelData, this.config.logLevel) <= 0) {
            console.log('DEBUG: ', message);
        }
    },

    info: function (message) {
        if (this.config.debuggable && _.indexOf(this.logLevelData, this.config.logLevel) <= 1) {
            console.log('INFO: ', message);
        }
    },

    warn: function (message) {
        if (this.config.debuggable && _.indexOf(this.logLevelData, this.config.logLevel) <= 2) {
            console.log('WARN: ', message);
        }
    },

    error: function (message) {
        if (this.config.debuggable && _.indexOf(this.logLevelData, this.config.logLevel) <= 3) {
            console.error('ERROR: ', message);
            throw new Error('ERROR: ' + message);
        }
    },
};

module.exports = logger;

},{"underscore":3}],11:[function(require,module,exports){
'use strict';

var Promise = require('es6-promise').Promise;
var _ = require('underscore');

var BaseState = require('./base-state');
var logger = require('./logger');
var util = require('./util');

var Machine = function (name, options) {
    BaseState.call(this, name, options);

    options = options || {};

    if (!_.isUndefined(options.data)) {
        this.set(options.data);
    }

    this.save();

    if (!_.isUndefined(options.props)) {
        this.setProp(options.props);
    }

    if (!_.isUndefined(options.methods)) {
        this.setMethod(options.methods);
    }

    this._deployed = false;
    this._chain = {
        main: null,
        activities: [],
        counter: 0,
    };

    this.appendRegion();
    this.setObserverType('outer-machine');
};

Machine.prototype = _.create(BaseState.prototype, {
    constructor: Machine,

    _cname: 'Machine',

    deploy: function () {
        var Transition, ConnectionPointPseudoState;
        Transition = require('./transition');
        ConnectionPointPseudoState = require('./pseudo-states').ConnectionPointPseudoState;

        this._deployed = true;
        this._chain.main = Promise.resolve();

        this._refresh(this._depth);

        util.eachElem(this, _.bind(function (elem) {
            elem._attached = true;
            elem.root = this;

            if (!(elem instanceof Machine)) {
                elem.addObserver('root', this);

                if (elem instanceof BaseState || elem instanceof Transition) {
                    elem.addObserver('parent', elem.parent);
                }
            }

            if (elem instanceof ConnectionPointPseudoState) {
                if (elem.parent === this) {
                    elem._isConnector = true;
                }
            }
        }, this));

        return this;
    },

    undeploy: function () {
        var Transition = require('./transition');

        this._deployed = false;
        this._chain.main = null;

        util.eachElem(this, _.bind(function (elem) {
            elem._attached = false;
            elem.root = null;

            if (!(elem instanceof Machine)) {
                elem.removeObserver('root', this);

                if (elem instanceof BaseState || elem instanceof Transition) {
                    elem.removeObserver('parent', elem.parent);
                }
            }

        }, this));

        this._refresh(this._depth);

        return this;
    },

    start: function (priority) {
        var message = {
            priority: null,
            deepHistory: false,
        };

        if (!_.isUndefined(priority)) {
            message.priority = priority;
        }

        if (!this._deployed) {
            logger.error('start()の前にdeploy()メソッドを実行してください。');
        }

        if (!this.isActive()) {
            logger.info('Machineインスタンス"' + this._name + '"が動作を開始しました。');

            this._addChain(_.bind(function () {
                this._entry(message);
                return Promise.resolve();
            }, this));

        } else {
            logger.warn('Machineインスタンス"' + this._name + '"はすでに起動しています。');
        }

        return this;
    },

    finish: function () {
        if (!this._deployed) {
            logger.error('deploy()メソッドがまだ実行されていません。');
        }

        if (this.isActive()) {
            this.completion();

        } else {
            logger.warn('Machineインスタンス"' + this._name + '"はすでに動作を終了しています。');
        }

        return this;
    },

    completion: function () {
        if (!this.isActive()) {
            logger.error(this._cname + 'インスタンス"' + this._name + '"はすでに非アクティブ化されています。');
        }

        this._addChain(_.bind(function () {
            this._exit();
            logger.info('Machineインスタンス"' + this._name + '"が動作を終了しました。');
            return Promise.resolve();
        }, this));
    },

    _addChain: function (callback) {
        this._chain.main = this._chain.main.then(callback).catch(this._onRejected);
    },

    _addActivity: function (callback) {
        this._chain.activities.push(callback);
    },

    _prevActivity: function (state) {
        if (_.isNull(this._chain.resolve)) {
            this._chain.counter += state.children.length;
        }
    },

    _afterActivity: function (state) {
        var self = this;
        if (!state._hasSubState()) {
            this._chain.counter -= 1;

            if (this._chain.counter <= 0) {
                this._chain.main = _.reduce(this._chain.activities, function (chain, activity) {
                    return chain.then(activity).catch(self._onRejected);
                }, this._chain.main);

                this._chain.activities.length = 0;
                this._chain.counter = 0;
            }
        }
    },

    _onAborted: function () {
        logger.info('Machineインスタンス"' + this._name + '"は処理を停止しました。');
    },

    _onRejected: function (e) {
        logger.info(e);
        return Promise.reject(e);
    },

    _inboundTransit: function (key) {
        var i, l, region, state;

        if (!_.isUndefined(key)) {
            if (_.isEmpty(key)) {
                logger.error('リンク先のEntryPointPseudoStateインスタンスに対応するキーが指定されてません。');
            }

            for (i = 0, l = this.children.length; i < l; i += 1) {
                region = this.children[i];
                state = region.children.states[key];
                if (!_.isUndefined(state)) {
                    this.start(state);
                    return;
                }
            }

            logger.error('エンドポイントのEntryPointPseudoStateインスタンスが指定されてません。');

        } else {
            this.start();
        }
    },

    _outboundTransit: function (state) {
        this.completion();

        this._addChain(_.bind(function () {
            this.notify('outer-machine', 'link-back', state.getId());
            return Promise.resolve();
        }, this));
    },

    update: function (event, callback) {
        var params = _.toArray(arguments).slice(1);

        switch (event) {
            case 'async':
                this._addChain(callback);
                break;

            case 'async-activity':
                this._addActivity(callback);
                break;

            case 'prev-activity':
                this._prevActivity.apply(this, params);
                break;

            case 'after-activity':
                this._afterActivity.apply(this, params);
                break;

            case 'entry':
                this._entry.apply(this, params);
                break;

            case 'exit':
                this._exit.apply(this, params);
                break;

            case 'completion':
                this.completion.apply(this, params);
                break;

            case 'termination':
                this._onAborted.apply(this, params);
                break;

            case 'link-forward':
                this._inboundTransit.apply(this, params);
                break;

            case 'exit-point':
                this._outboundTransit.apply(this, params);
                break;
        }
    },
});

var SubMachine = function (name) {
    BaseState.call(this, name);

    this._linkedMachine = null;
    this._deployed = false;

    this.appendRegion();
    this.setObserverType('inner-machine');
};

SubMachine.prototype = _.create(BaseState.prototype, {
    constructor: SubMachine,

    _cname: 'SubMachine',

    deploy: function () {
        var Region, ConnectionPointPseudoState, InitialPseudoState, FinalState;
        Region = require('./region');
        ConnectionPointPseudoState = require('./pseudo-states').ConnectionPointPseudoState;
        InitialPseudoState = require('./pseudo-states').InitialPseudoState;
        FinalState = require('./states').FinalState;

        this._deployed = true;

        util.eachElem(this, _.bind(function (elem) {
            if (elem instanceof ConnectionPointPseudoState) {
                elem.addObserver('sub-root', this);

                if (elem.parent === this) {
                    elem._isMediator = true;

                } else {
                    logger.error('ConnectionPointPseudoStateインスタンスはサブマシン直下のサブ状態でなければなりません。');
                }
            } else if (!(elem instanceof Region || elem instanceof SubMachine || elem instanceof InitialPseudoState || elem instanceof FinalState)) {
                logger.error('SubMachineインスタンスはConnectionPointPseudoStateクラス以外の状態を追加できません。');
            }
        }, this));

        return this;
    },

    undeploy: function () {
        var ConnectionPointPseudoState, InitialPseudoState, FinalState;
        ConnectionPointPseudoState = require('./pseudo-states').ConnectionPointPseudoState;
        InitialPseudoState = require('./pseudo-states').InitialPseudoState;
        FinalState = require('./states').FinalState;

        this._deployed = false;

        util.eachElem(this, _.bind(function (elem) {
            if (elem instanceof ConnectionPointPseudoState) {
                elem.removeObserver('sub-root', this);
                elem._isMediator = false;

            }
        }, this));

        return this;
    },

    link: function (machine) {
        if (!(machine instanceof Machine)) {
            logger.error('Machineインスタンスを指定してください。');
        }

        this._linkedMachine = machine;
        this.addObserver('inner-machine', machine);

        machine.addObserver('outer-machine', this);
    },

    unlink: function () {
        this.removeObserver('inner-machine', this._linkedMachine);

        this._linkedMachine.removeObserver('outer-machine', this);
        this._linkedMachine = null;
    },

    update: function (event) {
        var params = _.toArray(arguments).slice(1);

        switch (event) {
            case 'entry-point':
                this._linkForward.apply(this, params);
                break;

            case 'link-back':
                this._linkBack.apply(this, params);
                break;

            case 'entry':
                this._entry.apply(this, params);
                break;

            case 'exit':
                this._exit.apply(this, params);
                break;
        }
    },

    _linkForward: function (state) {
        this._async(function () {
            state._exit();
            this.notify('inner-machine', 'link-forward', state._key);
        });
    },

    _linkBack: function (id) {
        var exitPoint, i, l, region;

        for (i = 0, l = this.children.length; i < l; i += 1) {
            region = this.children[i];

            exitPoint = _.findWhere(region.children.states, {_key: id});

            if (!_.isUndefined(exitPoint)) {
                exitPoint._entry();
                return;
            }
        }

        logger.error('リンク先のEntryPointPseudoStateインスタンスに対応するキーが指定されてません。');
    },

    _entry: function (message) {
        if (!this._deployed) {
            logger.error('SubMachineインスタンスのdeploy()メソッドを実行してください。');
        }

        if (!this.isActive()) {
            this._activate();
            this.notify('children', 'entry', message);
        }
    },

    _exit: function () {
        if (!this._deployed) {
            logger.error('SubMachineインスタンスのdeploy()メソッドを実行してください。');
        }

        if (this.isActive()) {
            this.notify('children', 'exit');
            this._deactivate();
        }
    },
});

module.exports = {
    Machine: Machine,
    SubMachine: SubMachine,
};

},{"./base-state":7,"./logger":10,"./pseudo-states":15,"./region":16,"./states":17,"./transition":19,"./util":20,"es6-promise":1,"underscore":3}],12:[function(require,module,exports){
'use strict';

var _ = require('underscore');

var logger = require('./logger');

var mixin = {
    accessor: {
        has: function (query) {
            return this.model.has(query);
        },

        get: function (query) {
            return this.model.get(query);
        },

        set: function (query, value) {
            return this.model.set(query, value);
        },

        unset: function (query) {
            return this.model.unset(query);
        },

        save: function () {
            this.model.save();
        },

        restore: function () {
            this.model.restore();
        },

        clear: function () {
            this.model.clear();
        },

        getProp: function (query) {
            return this.model.getProp(query);
        },

        setProp: function (query, object) {
            return this.model.setProp(query, object);
        },

        getMethod: function (query) {
            return this.model.getMethod(query);
        },

        setMethod: function (query, object, context) {
            if (!_.isString(query)) {
                object = !_.isUndefined(object) ? object : this;
                return this.model.setMethod(query, object);
            } else {
                context = !_.isUndefined(context) ? context : this;
                return this.model.setMethod(query, object, context);
            }
        },

        mergeProp: function (query, object) {
            return this.model.mergeProp(query, object);
        },

        mergeMethod: function (query, object, context) {
            if (!_.isString(query)) {
                object = !_.isUndefined(object) ? object : this;
                return this.model.mergeMethod(query, object);
            } else {
                context = !_.isUndefined(context) ? context : this;
                return this.model.mergeMethod(query, object, context);
            }
        },

        watch: function (query, listener) {
            this.model.watch(query, listener);
        },

        unwatch: function (query, listener) {
            this.model.unwatch(query, listener);
        },
    },

    helper: {
        $has: function (query) {
            return $has(query, this);
        },

        $get: function (query) {
            return $get(query, this);
        },

        $set: function (query, value) {
            return $set(query, value, this);
        },

        $unset: function (query) {
            return $unset(query, this);
        },

        $getProp: function (query) {
            return $getProp(query, this);
        },

        $getMethod: function (query) {
            return $getMethod(query, this);
        },

        $setProp: function (query, prop) {
            return $setProp(query, prop, this);
        },

        $setMethod: function (query, method, context) {
            return $setMethod(query, method, context, this);
        },
    },

    disable: {
        has: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        get: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        set: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        unset: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        save: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        restore: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        clear: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        getProp: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        setProp: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        getMethod: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        setMethod: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        watch: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        unwatch: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        $getProp: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        $getMethod: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },
        $setProp: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        $setMethod: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        $has: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        $get: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        $set: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        $unset: function () {
            logger.error(this._cname + 'インスタンスは内部データを保持できません。');
        },

        addState: function () {
            logger.error(this._cname + 'インスタンスはサブ状態を持てません。');
        },

        removeState: function () {
            logger.error(this._cname + 'インスタンスはサブ状態を持てません。');
        },

        addTransition: function () {
            logger.error(this._cname + 'インスタンスは遷移を持てません。');
        },

        removeTransition: function () {
            logger.error(this._cname + 'インスタンスは遷移を持てません。');
        },

        appendRegion: function () {
            logger.error(this._cname + 'インスタンスは領域を持てません。');
        },

        removeRegion: function () {
            logger.error(this._cname + 'インスタンスは領域を持てません。');
        },
    },

    descriptor: {
        props: {
            enumerable: false,
            get: function () {
                return this.model.props;
            },
        },
        methods: {
            enumerable: false,
            get: function () {
                return this.model.methods;
            },
        },
    },
};

function $has(query, elem) {
    var result, next;
    result = elem.has(query);
    if (!result) {
        next = elem._type === 'region' ? elem.parent : elem.container;
        if (!_.isNull(next)) {
            result = $has(query, next);
        }
    }

    return result;
}

function $get(query, elem) {
    var result, next;
    result = elem.get(query);
    if (_.isUndefined(result)) {
        next = elem._type === 'region' ? elem.parent : elem.container;
        if (!_.isNull(next)) {
            result = $get(query, next);
        }
    }

    return result;
}

function $set(query, value, elem) {
    var result, next;
    result = elem.get(query);
    if (!_.isUndefined(result)) {
        result = elem.set(query, value);

    } else {
        next = elem._type === 'region' ? elem.parent : elem.container;
        if (!_.isNull(next)) {
            result = $set(query, value, next);
        }
    }

    return result;
}

function $unset(query, elem) {
    var result, next;
    result = elem.get(query);
    if (!_.isUndefined(result)) {
        result = elem.unset(query);

    } else {
        next = elem._type === 'region' ? elem.parent : elem.container;
        if (!_.isNull(next)) {
            result = $unset(query, next);
        }
    }

    return result;
}

function $getProp(query, elem) {
    var prop, next;
    prop = elem.getProp(query);
    if (_.isUndefined(prop)) {
        next = elem._type === 'region' ? elem.parent : elem.container;
        if (!_.isNull(next)) {
            prop = $getProp(query, next);
        }
    }

    return prop;
}

function $setProp(query, value, elem) {
    var prop, next;
    if (_.isFunction(value)) {
        logger.error('Functionはプロパティに登録できません。');
    }

    prop = elem.getProp(query);
    if (!_.isUndefined(prop)) {
        elem.setProp(query, value);

    } else {
        next = elem._type === 'region' ? elem.parent : elem.container;
        if (!_.isNull(next)) {
            $setProp(query, value, next);
        }
    }

    return value;
}

function $getMethod(query, elem) {
    var method, next;
    method = elem.getMethod(query);
    if (_.isUndefined(method)) {
        next = elem._type === 'region' ? elem.parent : elem.container;
        if (!_.isNull(next)) {
            method = $getMethod(query, next);
        }
    }

    return method;
}

function $setMethod(query, value, context, elem) {
    var method, next;
    if (!_.isFunction(value)) {
        logger.error('Function以外はメソッドに登録できません。');
    }

    method = elem.getMethod(query);
    if (!_.isUndefined(method)) {
        elem.setMethod(query, value, context);

    } else {
        next = elem._type === 'region' ? elem.parent : elem.container;
        if (!_.isNull(next)) {
            $setMethod(query, value, context, next);
        }
    }

    return value;
}

module.exports = mixin;

},{"./logger":10,"underscore":3}],13:[function(require,module,exports){
'use strict';

var _, Observable, logger, DELIMITER, trim, toString, getPrototypeOf, Model;

_ = require('underscore');
Observable = require('./observable');
logger = require('./logger');

DELIMITER = '/';

trim = (function () {
    var escaped, pattern;
    escaped = DELIMITER.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    pattern = new RegExp('^' + escaped + '+|' + escaped + '+$', 'g');

    return function (str) {
        return str.replace(pattern, '');
    };
}());

toString = Object.prototype.toString;
getPrototypeOf = Object.getPrototypeOf;

Model = function (data) {
    Observable.call(this);

    this._data = this._savedData = this.props = this.methods = this._temp = undefined;
    this._cache = {};

    if (!_.isUndefined(data)) {
        this.set(data);
    }
};

Model.prototype = _.create(Observable.prototype, {
    constructor: Model,

    _cname: 'Model',

    has: function (query) {
        return !_.isUndefined(this.get(query));
    },

    get: function (query) {
        var path, value;
        query = _normalizeQuery(query);
        path = _parseQuery(query);
        value = this._cache[query];

        if (_.isUndefined(value)) {
            if (path.length) {
                value = _.property(path)(this._data);

            } else {
                value = this._data;
            }

            if (!_.isUndefined(value)) {
                this._cache[query] = value;
            }
        }

        return value;
    },

    set: function (query, value) {
        var collection, parentPaths, destPaths, srcPaths, deletePaths, updatePaths, createPaths, path, oldValue, preData, postData, parentPath, parent;

        if (_.isUndefined(value)) {
            value = query;
            query = DELIMITER;
        }

        collection = [];
        parentPaths = _getParentPath(query);
        destPaths = [];
        srcPaths = [];

        query = _normalizeQuery(query);
        path = _parseQuery(query);
        oldValue = this.get(query);

        if (!_.isUndefined(oldValue)) {
            if (_.isEqual(oldValue, value)) {
                return value;
            }

            _getChildrenPath(oldValue, query, destPaths);
        }

        _getChildrenPath(value, query, srcPaths);

        deletePaths = _.difference(destPaths, srcPaths);
        updatePaths = _.intersection(destPaths, srcPaths).concat(parentPaths);
        createPaths = _.difference(srcPaths, destPaths);

        preData = _extend(undefined, this._data);
        this._temp = _extend(undefined, this._data);
        this._set('_temp', query, _extend(undefined, value));
        postData = this._temp;
        delete this._temp;

        _collect(preData, deletePaths, collection, 'delete');
        _collect(preData, updatePaths, collection, 'delete');
        _collect(postData, updatePaths, collection, 'create');
        _collect(postData, createPaths, collection, 'create');

        if (path.length) {
            parentPath = _.initial(path);

            if (parentPath.length) {
                parent = _.property(parentPath)(this._data);
            } else {
                parent = this._data;
            }

            parent[_.last(path)] = value;
        } else {
            this._data = value;
        }

        _.each(_.compact(_.map(_.groupBy(collection, '0'), function (array) {
            var deleted, created, object;

            if (array.length > 1) {
                deleted = array[0];
                created = array[1];
                if (!_.isEqual(deleted[2], created[2])) {
                    return {
                        target: deleted[0],
                        event: 'update',
                        value: created[2],
                        oldValue: deleted[2],
                    };
                }
            } else {
                object = array[0];
                return {
                    target: object[0],
                    event: object[1],
                    value: object[2],
                };
            }
        })), function (object) {
            if (!_.isUndefined(this._cache[object.target])) {
                if (object.event === 'delete') {
                    delete this._cache[object.target];
                } else {
                    this._cache[object.target] = object.value;
                }
            }

            this._bubbling(object);
        }, this);

        return value;
    },

    unset: function (query) {
        var path, value, collection, deletePaths, updatePaths, preData, postData, parentPath, parent;

        query = _normalizeQuery(query);
        path = _parseQuery(query);
        value = this.get(query);

        collection = [];
        deletePaths = [];
        updatePaths = _getParentPath(query);

        if (!_.isUndefined(value)) {
            _getChildrenPath(value, query, deletePaths);

            preData = _extend(undefined, this._data);
            this._temp = _extend(undefined, this._data);
            this._unset('_temp', query);
            postData = this._temp;
            delete this._temp;

            _collect(preData, deletePaths, collection, 'delete');
            _collect(preData, updatePaths, collection, 'delete');
            _collect(postData, updatePaths, collection, 'create');

            if (path.length) {
                parentPath = _.initial(path);

                if (parentPath.length) {
                    parent = _.property(parentPath)(this._data);
                } else {
                    parent = this._data;
                }

                delete parent[_.last(path)];
            } else {
                delete this._data;
            }

            _.each(_.compact(_.map(_.groupBy(collection, '0'), function (array) {
                var deleted, created;

                if (array.length > 1) {
                    deleted = array[0];
                    created = array[1];

                    return {
                        event: 'update',
                        target: deleted[0],
                        value: created[2],
                        oldValue: deleted[2],
                    };
                } else {
                    deleted = array[0];
                    return {
                        target: deleted[0],
                        event: deleted[1],
                        value: deleted[2],
                    };
                }
            })), function (object) {
                if (!_.isUndefined(this._cache[object.target])) {
                    if (object.event === 'delete') {
                        delete this._cache[object.target];
                    } else {
                        this._cache[object.target] = object.value;
                    }
                }

                this._bubbling(object);
            }, this);
        }

        return value;
    },

    merge: function (query) {
        var dest, srcs, collection;
        srcs = _.toArray(arguments);

        if (!_.isString(query)) {
            query = DELIMITER;
        } else {
            if (srcs.length > 1) {
                srcs = srcs.slice(1);
            } else {
                query = DELIMITER;
                srcs = srcs[0];
            }
        }

        query = _normalizeQuery(query);
        dest = this.get(query);

        collection = [];

        _.each(srcs, function (src) {
            var parentPaths, destPaths, srcPaths, updatePaths, createPaths, preData, postData;

            if (!_.isObject(src)) {
                logger.error('マージ元は配列か連想配列を指定してください。');
            }

            parentPaths = _getParentPath(query);
            destPaths = _getChildrenPath(dest, query).concat(parentPaths);
            srcPaths = _getMergedChildrenPath(dest, src, query).concat(parentPaths);

            updatePaths = _.intersection(destPaths, srcPaths);
            createPaths = _.difference(srcPaths, destPaths);

            preData = _extend(undefined, this._data);
            this._temp = _extend(undefined, this._data);
            this._merge('_temp', query, _extend(undefined, src));
            postData = this._temp;
            delete this._temp;

            _collect(preData, updatePaths, collection, 'delete');
            _collect(postData, updatePaths, collection, 'create');
            _collect(postData, createPaths, collection, 'create');

            dest = _merge(dest, src);
            //_merge(dest, src);

            _.each(_.compact(_.map(_.groupBy(collection, '0'), function (array, key) {
                var deleted, created;

                if (array.length > 1) {
                    deleted = array[0];
                    created = array[1];

                    if (!_.isEqual(deleted[2], created[2])) {
                        return {
                            event: 'update',
                            target: deleted[0],
                            value: created[2],
                            oldValue: deleted[2],
                        };
                    }
                } else {
                    created = array[0];
                    return {
                        target: key,
                        event: created[1],
                        value: created[2],
                    };
                }
            })), function (object) {
                if (!_.isUndefined(this._cache[object.target])) {
                    this._cache[object.target] = object.value;
                }

                this._bubbling(object);
            }, this);
        }, this);

        return dest;
    },

    save: function () {
        this._savedData = _extend(undefined, this._data);
    },

    restore: function () {
        if (!_.isUndefined(this._savedData)) {
            this.clear();
            this.set(this._savedData);
        }
    },

    clear: function () {
        delete this._data;

        _.each(_.keys(this._cache), function (key) {
            delete this._cache[key];
        }, this);
    },

    _get: function (type, query) {
        var path, value;
        query = _normalizeQuery(query);
        path = _parseQuery(query);
        if (path.length) {
            value = _.property(path)(this[type]);

        } else {
            value = this[type];
        }

        return value;
    },

    _set: function (type, query, value) {
        var path, parentPath, parent;

        query = _normalizeQuery(query);
        path = _parseQuery(query);

        if (path.length) {
            parentPath = _.initial(path);

            if (parentPath.length) {
                parent = _.property(parentPath)(this[type]);
            } else {
                parent = this[type];
            }

            parent[_.last(path)] = value;
        } else {
            this[type] = value;
        }

        return value;
    },

    _unset: function (type, query) {
        var path, value, parentPath, parent;

        query = _normalizeQuery(query);
        path = _parseQuery(query);
        value = this._get(type, query);

        if (path.length) {
            parentPath = _.initial(path);

            if (parentPath.length) {
                parent = _.property(parentPath)(this[type]);
            } else {
                parent = this[type];
            }

            delete parent[_.last(path)];
        } else {
            delete this[type];
        }

        return value;
    },

    _merge: function (type, query, value) {
        var path, oldValue, dest;

        query = _normalizeQuery(query);
        path = _parseQuery(query);
        oldValue = this._get(type, query);

        dest = _merge(oldValue, value);
        this._set(type, query, dest);

        return dest;
    },

    getProp: function (query) {
        return this._get('props', query);
    },

    setProp: function (query, prop) {
        if (_.isUndefined(prop)) {
            prop = query;
            query = DELIMITER;
        }

        _validateEach(prop, 'not-function');
        return this._set('props', query, prop);
    },

    getMethod: function (query) {
        return this._get('methods', query);
    },

    setMethod: function (query, method, context) {
        if (!_.isString(query)) {
            context = method;
            method = query;
            query = DELIMITER;
        }

        _validateEach(method, 'function-only');
        method = _bind(method, context);
        return this._set('methods', query, method);
    },

    mergeProp: function (query, prop) {
        if (_.isUndefined(prop)) {
            prop = query;
            query = DELIMITER;
        }

        _validateEach(prop, 'not-function');
        return this._merge('props', query, prop);
    },

    mergeMethod: function (query, method, context) {
        if (!_.isString(query)) {
            context = method;
            method = query;
            query = DELIMITER;
        }

        _validateEach(method, 'function-only');
        method = _bind(method, context);
        return this._merge('methods', query, method, context);
    },

    _test: function (method) {
        var params, result;
        params = _.toArray(arguments).slice(1);

        try {
            result = this[method].apply(this, params);

        } catch (e) {}

        return result;
    },

    _bubbling: function (object) {
        var propNamePath, currentTarget;
        propNamePath = _parseQuery(object.target);

        while (propNamePath.length) {
            currentTarget = propNamePath.join(DELIMITER);
            object.currentTarget = currentTarget;

            if (this.countListeners(currentTarget) > 0) {
                this.notifyListeners(currentTarget, object);
            }

            propNamePath.pop();
        }

        object.currentTarget = DELIMITER;
        if (this.countListeners(DELIMITER) > 0) {
            this.notifyListeners(DELIMITER, object);
        }
    },

    watch: function (query, listener) {
        if (_.isFunction(query)) {
            listener = query;
            query = DELIMITER;
        }
        query = _normalizeQuery(query);
        this.observe(query, listener);
    },

    unwatch: function (query, listener) {
        if (_.isFunction(query)) {
            listener = query;
            query = DELIMITER;
        }
        query = _normalizeQuery(query);
        this.unobserve(query, listener);
    },
});

function _collect(data, paths, collection, event) {
    collection = collection || [];

    _.each(paths, function (path) {
        var list, value;
        list = _parseQuery(path);

        if (list.length) {
            value = _.property(list)(data);

        } else {
            value = data;
        }

        if (event === 'create') {
            _validate(value, 'json');
        }

        collection.push([path, event, value]);
    });

    return collection;
}

function _bind(object, context) {
    if (_.isArray(object) || _isPlainObject(object)) {
        _.each(object, function (value, key) {
            object[key] = _bind(value, context);
        });
    } else {
        object = _.bind(object, context);
    }

    return object;
}

function _getMergedChildrenPath(dest, src, currentPath, collection) {
    var destLength;
    currentPath = !_.isUndefined(currentPath) ? currentPath : DELIMITER;
    collection = !_.isUndefined(collection) ? collection : [];

    if (_.isArray(src)) {
        destLength = _.isArray(dest) ? dest.length : 0;

        _.each(src, function (element, index) {
            var currentIndex, path;
            currentIndex = '' + (destLength + index);
            path = currentPath !== DELIMITER ? currentPath + DELIMITER + currentIndex : currentIndex;

            _getMergedChildrenPath(undefined, element, path, collection);
        });
    } else if (_isPlainObject(src)) {
        _.each(src, function (value, key) {
            var path, destChild;
            path = currentPath !== DELIMITER ? currentPath + DELIMITER + key : key;
            destChild = _isPlainObject(dest) ? dest[key] : undefined;
            _getMergedChildrenPath(destChild, value, path, collection);
        });
    }

    collection.push(currentPath);
    return collection;
}

function _getChildrenPath(object, currentPath, collection) {
    currentPath = !_.isUndefined(currentPath) ? currentPath : DELIMITER;
    collection = !_.isUndefined(collection) ? collection : [];

    if (_.isObject(object)) {
        _.each(object, function (value, key) {
            var path = currentPath !== DELIMITER ? currentPath + DELIMITER + key : key;
            _getChildrenPath(value, path, collection);
        });
    }

    collection.push(currentPath);
    return collection;
}

function _getParentPath(query, collection) {
    var path = _parseQuery(query);
    collection = !_.isUndefined(collection) ? collection : [];

    if (path.length) {
        path = _.initial(path);

        while (path.length) {
            collection.push(path.join(DELIMITER));
            path.pop();
        }

        collection.push(DELIMITER);
    }

    return collection;
}

function _extend(dest, src) {
    var i, l, keys, key, value;
    if (_.isArray(src)) {
        dest = dest || [];

        for (i = 0, l = src.length; i < l; i += 1) {
            value = !_.isObject(src[i]) ? src[i] : _extend(undefined, src[i]);
            dest.push(value);
        }
    } else if (_isPlainObject(src)) {
        dest = dest || {};
        keys = _.keys(src);

        for (i = 0, l = keys.length; i < l; i += 1) {
            key = keys[i];
            value = !_.isObject(src[key]) ? src[key] : _extend(dest[key], src[key]);
            dest[key] = value;
        }
    } else {
        dest = src;
    }

    return dest;
}

function _merge(dest) {
    var srcs = _.toArray(arguments).slice(1);

    _.each(srcs, function (src) {
        dest = _extend(dest, src);
    });

    return dest;
}

function _validateEach(value, required) {
    var result = false;

    if (_.isArray(value) || _isPlainObject(value)) {
        result = _.every(value, function (element) {
            return _validateEach(element, required);
        });
    } else {
        result = _validate(value, required);
    }

    return result;
}

function _validate(value, required) {
    var result = false;

    switch (required) {
        case 'json':
        if (_isPlainObject(value) || _.isArray(value) || _.isNull(value) ||
        _.isString(value) || _.isNumber(value) || _.isBoolean(value)) {
            result = true;

        } else {
            logger.error('JSONデータ型以外はデータに登録できません。');
        }

        break;

        case 'function-only':
        if (_.isFunction(value)) {
            result = true;

        } else {
            logger.error('Function以外はメソッドに登録できません。');
        }
        break;

        case 'not-function':
        if (!_.isFunction(value)) {
            result = true;

        } else {
            logger.error('Functionはプロパティに登録できません。');
        }
        break;
    }

    return result;
}

function _normalizeQuery(query) {
    if (_.isUndefined(query)) {
        query = DELIMITER;

    } else if (!_.isString(query)) {
        logger.error('クエリは文字列で指定してください。');
    }

    if (query !== DELIMITER) {
        query = trim(query);
    }

    return query;
}

function _parseQuery(query) {
    query = !_.isString(query) ? '' + query : query;

    if (query !== DELIMITER) {
        return query.split(DELIMITER);
    } else {
        return [];
    }
}

function _isPlainObject(obj) {
    var result, proto;
    result = false;
    if (toString.call(obj) === '[object Object]') {
        proto = obj;
        while (!_.isNull(getPrototypeOf(proto))) {
            proto = getPrototypeOf(proto);
        }
        result = getPrototypeOf(obj) === proto;
    }
    return result;
}

module.exports = Model;

},{"./logger":10,"./observable":14,"underscore":3}],14:[function(require,module,exports){
'use strict';

var _ = require('underscore');

var Observable = function () {
    this._listeners = {};
};

Observable.prototype = _.create(Object.prototype, {
    constructor: Observable,

    _cname: 'Observable',

    hasListener: function (state, listener) {
        var result = false;
        if (!_.isUndefined(this._listeners[state])) {
            if (_.indexOf(this._listeners[state], listener) > -1) {
                result = true;
            }
        }
        return result;
    },

    countListeners: function (state) {
        var result = 0;
        if (!_.isUndefined(this._listeners[state])) {
            result = this._listeners[state].length;
        }

        return result;
    },

    observe: function (state, listener) {
        if (_.isUndefined(this._listeners[state])) {
            this._listeners[state] = [];
        }

        if (_.isFunction(listener)) {
            this._listeners[state].push(listener);
        }
    },

    unobserve: function (state, listener) {
        var listeners, index;
        listeners = this._listeners[state];

        if (_.isUndefined(listeners)) {
            return;
        }

        index = _.indexOf(listeners, listener);
        if (index > -1) {
            listeners.splice(index, 1);
        }
    },

    notifyListeners: function (state, params) {
        var listeners, i, l, listener;
        listeners = this._listeners[state];

        if (_.isUndefined(listeners)) {
            return;
        }

        for (i = 0, l = listeners.length; i < l; i += 1) {
            listener = listeners[i];
            if (_.isFunction(listener)) {
                params = _.isArray(params) ? params : _.toArray(arguments).slice(1);
                listener.apply(null, params);
            }
        }
    },
});

module.exports = Observable;

},{"underscore":3}],15:[function(require,module,exports){
'use strict';

var _ = require('underscore');

var BaseState = require('./base-state');

var logger = require('./logger');
var util = require('./util');
var mixin = require('./mixin');

var PseudoState = function (name) {
    BaseState.call(this, name);

    this._type = 'pseudo-state';
};

PseudoState.prototype = _.create(BaseState.prototype, _.extend({
    constructor: PseudoState,

    _cname: 'PseudoState',

    _deactivate: function () {
        this._status = 'inactive';

        if (!_.isNull(this.container)) {
            this.notify('container', 'set-previous-state', null);
        }

        logger.info(this._cname + 'インスタンス"' + this._name + '"が非アクティブ化されました。');
    },
}, mixin.disable));

var InitialPseudoState = function (name) {
    PseudoState.call(this, name);
};

InitialPseudoState.prototype = _.create(PseudoState.prototype, {
    constructor: InitialPseudoState,

    _cname: 'InitialPseudoState',

    _activate: function () {
        var transit;

        this._status = 'active';
        logger.info('InitialPseudoStateインスタンス"' + this._name + '"がアクティブ化されました。');

        if (!_.isNull(this.container)) {
            transit = util.findFirstTransition(this.container);
            if (!_.isUndefined(transit)) {
                transit.trigger();

            } else {
                logger.error('Regionインスタンス"' + this.container._name + '"の初期遷移が見つかりません。');
            }
        }
    },
});

var HistoryPseudoState = function (name, deep) {
    PseudoState.call(this, name);

    this._isDeep = !_.isUndefined(deep) ? deep : false;
};

HistoryPseudoState.prototype = _.create(PseudoState.prototype, {
    constructor: HistoryPseudoState,

    _cname: 'HistoryPseudoState',

    _activate: function () {
        var container, state;

        this._status = 'active';
        logger.info('HistoryPseudoStateインスタンス"' + this._name + '"がアクティブ化されました。');

        if (!_.isNull(this.container)) {
            container = this.container;
            state = container._previousState || container._initialPseudo;

            if (state instanceof InitialPseudoState) {
                this._async(function () {
                    this._exit();
                    state.update('entry');
                });
            } else {
                this._async(function () {
                    this._exit();
                    state.update('entry', {
                        priority: null,
                        deepHistory: this._isDeep,
                    });
                });
            }
        }
    },
});

var TerminatePseudoState = function (name) {
    PseudoState.call(this, name);
};

TerminatePseudoState.prototype = _.create(PseudoState.prototype, {
    constructor: TerminatePseudoState,

    _cname: 'TerminatePseudoState',

    _activate: function () {
        this._status = 'active';
        logger.info('TerminatePseudoStateインスタンス"' + this._name + '"がアクティブ化されました。');

        this.notify('root', 'termination', this);
        logger.error('停止状態に遷移しました。処理を中断します。');
    },
});

var ChoicePseudoState = function (name, condition) {
    PseudoState.call(this, name);

    this._condition = _.isFunction(condition) ? condition : _.noop;
};

ChoicePseudoState.prototype = _.create(PseudoState.prototype, {
    constructor: ChoicePseudoState,

    _cname: 'ChoicePseudoState',

    _activate: function () {
        var target, transit;
        transit = util.findRelatedTransition(this);

        this._status = 'active';
        logger.info('ChoicePseudoStateインスタンス"' + this._name + '"がアクティブ化されました。');

        target = this._condition(transit);
        if (!(target instanceof BaseState)) {
            logger.error('遷移先のStateインスタンスが存在しません。');
        }

        if (!_.isNull(this.container)) {
            transit = util.findNextTransition(this.container, this, target);
            if (!_.isUndefined(transit)) {
                transit.trigger();

            } else {
                logger.error('ChoicePseudoStateインスタンス"' + this._name + '"起点のTransitionインスタンスが見つかりません。');
            }
        }
    },
});

var ConnectionPointPseudoState = function (name) {
    PseudoState.call(this, name);

    this._key = '';
    this._isMediator = false;
    this._isConnector = false;
    this.setObserverType('sub-root');
};

ConnectionPointPseudoState.prototype = _.create(PseudoState.prototype, {
    constructor: ConnectionPointPseudoState,

    _cname: 'ConnectionPointPseudoState',

    setKey: function (key) {
        this._key = key;
        return key;
    },
});

var EntryPointPseudoState = function (name) {
    ConnectionPointPseudoState.call(this, name);
};

EntryPointPseudoState.prototype = _.create(ConnectionPointPseudoState.prototype, {
    constructor: EntryPointPseudoState,

    _cname: 'EntryPointPseudoState',

    _activate: function () {
        var transit;

        this._status = 'active';
        logger.info('EntryPointPseudoStateインスタンス"' + this._name + '"がアクティブ化されました。');

        if (this._isMediator) {
            this.notify('sub-root', 'entry-point', this);

        } else {
            if (!_.isNull(this.container)) {
                transit = util.findFirstTransition(this.container, this);
                if (!_.isUndefined(transit)) {
                    transit.trigger();

                } else {
                    logger.error('Regionインスタンス"' + this.container._name + '"の初期遷移が見つかりません。');
                }
            }
        }
    },
});

var ExitPointPseudoState = function (name) {
    ConnectionPointPseudoState.call(this, name);
};

ExitPointPseudoState.prototype = _.create(ConnectionPointPseudoState.prototype, {
    constructor: ExitPointPseudoState,

    _cname: 'ExitPointPseudoState',

    _activate: function () {
        var upperContainer, transit;

        this._status = 'active';
        logger.info('ExitPointPseudoStateインスタンス"' + this._name + '"がアクティブ化されました。');

        if (this._isConnector) {
            this.notify('root', 'exit-point', this);

        } else {
            upperContainer = this.container._getUpperContainer();
            if (!_.isNull(upperContainer)) {
                transit = util.findNextTransition(upperContainer, this);

                if (!_.isUndefined(transit)) {
                    transit.trigger();

                } else {
                    logger.error('ExitPointPseudoStateインスタンス"' + this._name + '"起点のTransitionインスタンスが見つかりません。');
                }
            } else {
                logger.error('ExitPointPseudoStateインスタンス"' + this._name + '"の上位コンテナが存在しません。');
            }
        }
    },
});

module.exports = {
    PseudoState: PseudoState,
    InitialPseudoState: InitialPseudoState,
    HistoryPseudoState: HistoryPseudoState,
    TerminatePseudoState: TerminatePseudoState,
    ChoicePseudoState: ChoicePseudoState,
    ConnectionPointPseudoState: ConnectionPointPseudoState,
    EntryPointPseudoState: EntryPointPseudoState,
    ExitPointPseudoState: ExitPointPseudoState,
};

},{"./base-state":7,"./logger":10,"./mixin":12,"./util":20,"underscore":3}],16:[function(require,module,exports){
'use strict';

var _ = require('underscore');

var Elem = require('./elem');
var logger = require('./logger');
var util = require('./util');

var Region = function (name, options) {
    Elem.call(this, name);

    this._type = 'region';

    options = options || {};

    if (!_.isUndefined(options.data)) {
        this.set(options.data);
    }

    this.save();

    if (!_.isUndefined(options.props)) {
        this.setProp(options.props);
    }

    if (!_.isUndefined(options.methods)) {
        this.setMethod(options.methods);
    }

    this._initialPseudo = null;
    this._final = null;
    this._historyPseudo = null;
    this._previousState = null;

    this.children = {
        states: [],
        transitions: [],
    };

    this.setObserverType('states', 'transits');
    this._setDefaultStates();
};

Region.prototype = _.create(Elem.prototype, {
    constructor: Region,

    _cname: 'Region',

    setName: function (name, automatical) {
        this._name = name;
        if (!this._originalName && util.isFalsy(automatical)) {
            this._originalName = name;
        }

        this._setDefaultStateName();
        return name;
    },

    hasHistory: function (deep) {
        return util.isFalsy(deep) ? !_.isNull(this._historyPseudo) :
            !_.isNull(this._historyPseudo) && this._historyPseudo._isDeep;
    },

    getIndex: function () {
        var result = -1;

        if (!_.isNull(this.parent)) {
            result = _.indexOf(this.parent.children, this);
        }

        return result;
    },

    getStateByName: function (stateName) {
        return _.find(this.children.states, function (state) {
            return state.getName() === stateName;
        });
    },

    getTransitionByName: function (transitionName) {
        return _.find(this.children.transitions, function (transit) {
            return transit.getName() === transitionName;
        });
    },

    getStateById: function (stateId) {
        return _.find(this.children.states, function (state) {
            return state.getId() === stateId;
        });
    },

    getTransitionById: function (transitionId) {
        return _.find(this.children.transitions, function (transit) {
            return transit.getId() === transitionId;
        });
    },

    findActiveState: function () {
        return _.find(this.children.states, function (state) {
            return state.isActive();
        });
    },

    addState: function () {
        var BaseState, Machine, InitialPseudoState, HistoryPseudoState, FinalState, states, i, l, state, currentDepth;
        BaseState = require('./base-state');
        Machine = require('./machines').Machine;
        HistoryPseudoState = require('./pseudo-states').HistoryPseudoState;
        InitialPseudoState = require('./pseudo-states').InitialPseudoState;
        FinalState = require('./states').FinalState;

        if (this._attached) {
            logger.error('デプロイ後は要素の追加/削除はできません。Machineクラスのundeploy()メソッドでデプロイを取り消してください。');
        }

        states = _.toArray(arguments);

        for (i = 0, l = states.length; i < l; i += 1) {
            state = states[i];

            if (state instanceof Machine || !(state instanceof BaseState)) {
                logger.error('Stateインスタンスを指定してください。');
            }

            if (state instanceof InitialPseudoState) {
                this._initialPseudo = state;

            } else if (state instanceof FinalState) {
                this._final = state;

            } else if (state instanceof HistoryPseudoState) {
                this._historyPseudo = state;
            }

            this.children.states.push(state);
            this.children.states[state._id] = state;
            this.addObserver('children', state);
            this.addObserver('states', state);

            state.container = this;
            state.addObserver('container', this);

            currentDepth = this._getParentDepth() + 1;

            state._refresh(currentDepth);
        }

        return states.length > 1 ? states : _.first(states);
    },

    /* 引数にStateインスタンスを複数指定可 */
    removeState: function () {
        var HistoryPseudoState, states, i, state;
        HistoryPseudoState = require('./pseudo-states').HistoryPseudoState;

        if (this._attached) {
            logger.error('デプロイ後は要素の追加/削除はできません。Machineクラスのundeploy()メソッドでデプロイを取り消してください。');
        }

        states = _.toArray(arguments);

        for (i = this.children.states.length; i--;) {
            state = this.children.states[i];

            if (_.indexOf(states, state) > -1) {
                if (state instanceof HistoryPseudoState) {
                    this._historyPseudo = null;
                }

                this.children.states.splice(i, 1);
                delete this.children.states[state._id];

                this.removeObserver('children', state);
                this.removeObserver('states', state);

                state.container = null;
                state.removeObserver('container', this);

                state._refresh(0);
            }
        }

        return states.length > 1 ? states : _.first(states);
    },

    addTransition: function () {
        var InitialPseudoState, FinalState, Transition, transits, i, l, transit, result, currentDepth;
        InitialPseudoState = require('./pseudo-states').InitialPseudoState;
        FinalState = require('./states').FinalState;
        Transition = require('./transition');

        if (this._attached) {
            logger.error('デプロイ後は要素の追加/削除はできません。Machineクラスのundeploy()メソッドでデプロイを取り消してください。');
        }

        transits = _.toArray(arguments);

        for (i = 0, l = transits.length; i < l; i += 1) {
            transit = transits[i];

            if (!(transit instanceof Transition)) {
                logger.error('Transitionインスタンスを指定してください。');
            }

            if (transit._rawSource === InitialPseudoState || util.isFalsy(transit._rawSource)) {
                transit.source = this._initialPseudo;

            } else {
                result = util.findState(this, transit._rawSource, 0);

                if (_.isUndefined(result)) {
                    result = util.findState(this, transit._rawSource, 1);

                    if (!_.isUndefined(result)) {
                        transit._exitViaExitPoint = true;

                    } else {
                        logger.error('遷移元のStateインスタンスが見つかりません。');
                    }
                }

                transit.source = transit._rawSource;
            }

            if (transit._rawTarget === FinalState || util.isFalsy(transit._rawTarget)) {
                transit.target = this._final;

            } else {
                result = util.findState(this, transit._rawTarget, 0);

                if (_.isUndefined(result)) {
                    result = util.findState(this, transit._rawTarget, 1);

                    if (!_.isUndefined(result)) {
                        transit._isExplicitEntry = true;

                    } else {
                        logger.error('遷移先のStateインスタンスが見つかりません。');
                    }
                }

                transit.target = transit._rawTarget;
            }

            transit.addObserver('source', transit.source);
            transit.addObserver('target', transit.target);

            if (!transit._originalName) {
                transit.setName('transit-from-' + transit.source._name + '-to-' + transit.target._name, true);
            }

            this.children.transitions.push(transit);
            this.children.transitions[transit._id] = transit;
            this.addObserver('children', transit);
            this.addObserver('transits', transit);

            transit.container = this;
            transit.addObserver('container', this);

            currentDepth = this._getParentDepth() + 1;

            transit._refresh(currentDepth);
        }

        return transits.length > 1 ? transits : _.first(transits);
    },

    removeTransition: function () {
        var transits, i, transit;
        if (this._attached) {
            logger.error('デプロイ後は要素の追加/削除はできません。Machineクラスのundeploy()メソッドでデプロイを取り消してください。');
        }

        transits = _.toArray(arguments);

        for (i = this.children.transitions.length; i--;) {
            transit = this.children.transitions[i];

            if (_.indexOf(transits, transit) > -1) {
                this.children.transitions.splice(i, 1);
                delete this.children.transitions[transit._id];
                this.removeObserver('children', transit);
                this.removeObserver('transits', transit);

                transit.removeObserver('source', transit.source);
                transit.removeObserver('target', transit.target);

                if (!transit._originalName) {
                    transit.setName(transit._id, true);
                }

                transit.container = null;
                transit.removeObserver('container', this);

                transit._refresh(0);
            }
        }

        return transits.length > 1 ? transits : _.first(transits);
    },

    update: function (event) {
        var params = _.toArray(arguments).slice(1);

        switch (event) {
            case 'entry':
                this._entry.apply(this, params);
                break;

            case 'exit':
                this._exit.apply(this, params);
                break;

            case 'refresh':
                this._refresh.apply(this, params);
                break;

            case 'completion':
                this._completion.apply(this, params);
                break;

            case 'set-previous-state':
                this._setPreviousState.apply(this, params);
                break;
        }
    },

    _getParentDepth: function () {
        var result = -1;
        if (!_.isNull(this.parent)) {
            result = this.parent._depth;
        }

        return result;
    },

    _getUpperContainer: function () {
        var result = null;
        if (!_.isNull(this.parent) && !_.isNull(this.parent.container)) {
            result = this.parent.container;
        }

        return result;
    },

    _setDefaultStates: function () {
        var InitialPseudoState = require('./pseudo-states').InitialPseudoState;
        var FinalState = require('./states').FinalState;
        var initialPseudo, final;
        if (!_.isNull(this._initialPseudo) || !_.isNull(this._final)) {
            return;
        }

        initialPseudo = new InitialPseudoState(false);
        final = new FinalState(false);

        this.addState(initialPseudo, final);
        this._setDefaultStateName();
    },

    _setDefaultStateName: function () {
        this._initialPseudo.setName('initial-pseudo-state-in-' + this._name, true);
        this._final.setName('final-state-in-' + this._name, true);
    },

    _refresh: function (depth) {
        var currentDepth;
        depth = !_.isUndefined(depth) ? depth : this._getParentDepth();
        currentDepth = depth + 1;
        this.notify('children', 'refresh', currentDepth);
    },

    _setPreviousState: function (state) {
        this._previousState = state;
        return state;
    },

    _entry: function (message) {
        var SubMachine, PseudoState, state;
        SubMachine = require('./machines').SubMachine;
        PseudoState = require('./pseudo-states').PseudoState;
        if (!this.isActive()) {
            this._activate();

            if (_.indexOf(this.children.states, message.priority) > -1) {
                state = message.priority;
                message.priority = null;

            } else if (this.parent instanceof SubMachine) {
                this.parent.notify('inner-machine', 'link-forward');
                return;

            } else {
                if (message.deepHistory) {
                    state = this._previousState || this._initialPseudo;

                } else if (!_.isNull(this._historyPseudo)) {
                    state = this._historyPseudo;

                    if (state._isDeep) {
                        message.deepHistory = true;
                    }
                } else {
                    state = this._initialPseudo;
                }
            }

            if (!(state instanceof PseudoState)) {
                this._async(function () {
                    state.update('entry', message);
                });
            } else {
                state.update('entry', message);
            }
        }
    },

    _exit: function () {
        if (this.isActive()) {
            this.notify('states', 'exit');
            this._deactivate();
        }
    },

    _completion: function () {
        this._deactivate();

        if (!_.isNull(this.parent)) {
            if (_.every(this.parent.children, function (region) {
                return !region.isActive();
            })) {
                this.notify('parent', 'completion');
            }
        }
    },
});

module.exports = Region;

},{"./base-state":7,"./elem":8,"./logger":10,"./machines":11,"./pseudo-states":15,"./states":17,"./transition":19,"./util":20,"underscore":3}],17:[function(require,module,exports){
'use strict';

var _ = require('underscore');

var BaseState = require('./base-state');
var logger = require('./logger');
var util = require('./util');
var mixin = require('./mixin');
var max = Math.max;

var State = function (name, options) {
    BaseState.call(this, name);

    options = _.defaults(options || {}, _.clone(State.options));

    if (!_.isUndefined(options.data)) {
        this.set(options.data);
    }

    this.save();

    if (!_.isUndefined(options.props)) {
        this.setProp(options.props);
    }

    if (!_.isUndefined(options.methods)) {
        this.setMethod(options.methods);
    }

    this.entryAction = options.entryAction;
    this.exitAction = options.exitAction;
    this.doActivity = options.doActivity;

    this.autoTransition = options.autoTransition;

    this._loop = options.loop;
    this._fps = options.fps;
    this._interval = 1000 / this._fps;
    this._useRAF = options.useRAF;

    this._timerId = 0;
    this._ticks = 0;
    this._elapsedTime = 0;
    this._lastTime = 0;

    this._setTimer = (this._useRAF && !_.isUndefined(util.global.requestAnimationFrame)) ?
        this._requestAnimFrame : this._setTimeout;

    this._clearTimer = (this._useRAF && !_.isUndefined(util.global.requestAnimationFrame)) ?
        this._cancelAnimFrame : this._clearTimeout;
};

State.options = {
    entryAction: _.noop,
    exitAction: _.noop,
    doActivity: _.noop,

    autoTransition: false,
    loop: false,
    fps: 60,
    useRAF: false,
};

State.prototype = _.create(BaseState.prototype, {
    constructor: State,

    _cname: 'State',

    getTicks: function () {
        if (!this._loop) {
            logger.error('Stateインスタンスのloopオプションが指定されてません。');
        }

        return this._ticks;
    },

    getElapsedTime: function () {
        if (!this._loop) {
            logger.error('Stateインスタンスのloopオプションが指定されてません。');
        }

        return this._elapsedTime;
    },

    completion: function () {
        var params = _.toArray(arguments);

        if (!this.isActive()) {
            logger.error(this._cname + 'インスタンス"' + this._name + '"はすでに非アクティブ化されています。');
        }

        this._async(function () {
            var transit;
            if (!_.isNull(this.container)) {
                transit = util.findNextTransition(this.container, this);
                if (!_.isUndefined(transit)) {
                    transit.trigger.apply(transit, params);

                } else {
                    this._exit();
                    this.notify('container', 'completion');
                }
            }
        });
    },

    update: function (event) {
        var params = _.toArray(arguments).slice(1);

        switch (event) {
            case 'entry':
                this._entry.apply(this, params);
                break;

            case 'exit':
                this._exit.apply(this, params);
                break;

            case 'refresh':
                this._refresh.apply(this, params);
                break;

            case 'completion':
                this.completion.apply(this, params);
                break;
        }
    },

    _requestAnimFrame: function (callback) {
        var loop;
        callback = _.bind(callback, this);

        this.resetTimer();

        loop = _.bind(function (currentTime) {
            var delta;
            this._timerId = requestAnimationFrame(loop);

            delta = this._lastTime !== 0 ? currentTime - this._lastTime : 0;
            this._elapsedTime += delta;
            this._lastTime = currentTime;
            this._ticks += 1;

            callback(delta);
        }, this);

        this._timerId = requestAnimationFrame(loop);
    },

    _cancelAnimFrame: function () {
        cancelAnimationFrame(this._timerId);
    },

    resetTimer: function () {
        this._lastTime = 0;
        this._elapsedTime = 0;
        this._ticks = 0;
    },

    _setTimeout: function (callback) {
        var loop;
        callback = _.bind(callback, this);

        this.resetTimer();

        loop = _.bind(function () {
            var timeToCall = this._tick(callback);
            this._timerId = setTimeout(loop, timeToCall);
        }, this);

        this._timerId = setTimeout(loop, 0);
    },

    _clearTimeout: function () {
        clearTimeout(this._timerId);
    },

    _tick: function (callback) {
        var currentTime, deltaTime, processingTime, timeToCall;

        currentTime = _.now();
        deltaTime = this._lastTime === 0 ? 0 : currentTime - this._lastTime;

        this._elapsedTime += deltaTime;
        this._lastTime = currentTime;
        this._ticks += 1;

        callback(deltaTime);
        processingTime = _.now() - currentTime;
        timeToCall = max(this._interval - processingTime, 0);
        return timeToCall;
    },

    _activate: function () {
        var transit = util.findRelatedTransition(this);
        this._status = 'active';
        logger.info(this._cname + 'インスタンス"' + this._name + '"がアクティブ化されました。');

        this.entryAction(transit);

        this.notify('root', 'prev-activity', this);

        this.notify('root', 'async-activity', _.bind(function () {
            if (this._loop) {
                this._setTimer(function (deltaTime) {
                    this.doActivity(deltaTime, transit);

                    if (this.autoTransition) {
                        this.completion();
                    }
                });
            } else {
                this.doActivity(transit);

                if (this.autoTransition) {
                    this.completion();
                }
            }
        }, this));

        this.notify('root', 'after-activity', this);
    },

    _deactivate: function () {
        var transit = util.findRelatedTransition(this);
        this._clearTimer();

        if (!_.isNull(this.container)) {
            this.notify('container', 'set-previous-state', this);
        }

        this.exitAction(transit);

        this._status = 'inactive';
        logger.info(this._cname + 'インスタンス"' + this._name + '"が非アクティブ化されました。');

    },
});

var FinalState = function (name) {
    BaseState.call(this, name);
};

FinalState.prototype = _.create(BaseState.prototype, _.extend({
    constructor: FinalState,

    _cname: 'FinalState',

    _activate: function () {
        this._status = 'active';
        logger.info('FinalStateインスタンス"' + this._name + '"がアクティブ化されました。');

        this.completion();
    },

    _deactivate: function () {
        this._status = 'inactive';

        if (!_.isNull(this.container)) {
            this.notify('container', 'set-previous-state', null);
        }

        logger.info('FinalStateインスタンス"' + this._name + '"が非アクティブ化されました。');
    },
}, mixin.disable));

module.exports = {
    State: State,
    FinalState: FinalState,
};

},{"./base-state":7,"./logger":10,"./mixin":12,"./util":20,"underscore":3}],18:[function(require,module,exports){
'use strict';

var _ = require('underscore');

var Subject = function () {
    this._observers = {};
};

Subject.prototype = _.create(Object.prototype, {
    constructor: Subject,

    _cname: 'Subject',

    hasObserver: function (type, observer) {
        var result = false;
        if (!_.isUndefined(this._observers[type])) {
            if (_.indexOf(this._observers[type], observer) > -1) {
                result = true;
            }
        }
        return result;
    },

    countObservers: function (type) {
        var result = 0;
        if (!_.isUndefined(this._observers[type])) {
            result = this._observers[type].length;
        }

        return result;
    },

    setObserverType: function (types) {
        var type, i, l;
        types = _.isArray(types) ? types : _.toArray(arguments);

        for (i = 0, l = types.length; i < l; i += 1) {
            type = types[i];
            if (_.isUndefined(this._observers[type])) {
                this._observers[type] = [];
            }
        }
    },

    addObserver: function (type, observer) {

        if (_.isUndefined(this._observers[type])) {
            this._observers[type] = [];
        }

        if (_.isObject(observer) && !_.isFunction(observer)) {
            this._observers[type].push(observer);
        }
    },

    removeObserver: function (type, observer) {
        var observers, index;
        observers = this._observers[type];

        if (_.isUndefined(observers)) {
            return;
        }

        index = _.indexOf(observers, observer);
        if (index > -1) {
            observers.splice(index, 1);
        }
    },

    notify: function (type) {
        var observers, i, l, observer, params;
        observers = this._observers[type];

        if (_.isUndefined(observers)) {
            return;
        }

        for (i = 0, l = observers.length; i < l; i += 1) {
            observer = observers[i];
            if (_.isFunction(observer.update)) {
                params = _.toArray(arguments).slice(1);
                observer.update.apply(observer, params);
            }
        }
    },
});

module.exports = Subject;

},{"underscore":3}],19:[function(require,module,exports){
'use strict';

var _ = require('underscore');

var Elem = require('./elem');
var BaseState = require('./base-state');
var FinalState = require('./states').FinalState;
var InitialPseudoState = require('./pseudo-states').InitialPseudoState;
var TerminatePseudoState = require('./pseudo-states').TerminatePseudoState;

var logger = require('./logger');
var util = require('./util');

var Transition = function (name, source, target, options) {
    Elem.call(this, name);

    this._type = 'transition';

    if (source === FinalState) {
        logger.error('終了状態を遷移元にすることはできません。');

    } else if (source instanceof TerminatePseudoState) {
        logger.error('停止状態を遷移元にすることはできません。');

    } else if (source instanceof BaseState || util.isFalsy(source) || InitialPseudoState) {
        this._rawSource = source;

    } else {
        logger.error('第2引数に遷移元のStateインスタンス、またはfalseを指定してください。');
    }

    if (target === InitialPseudoState) {
        logger.error('開始擬似状態を遷移先にすることはできません。');

    } else if (target instanceof BaseState || util.isFalsy(target) || FinalState) {
        this._rawTarget = target;

    } else {
        logger.error('第3引数に遷移先のStateインスタンス、またはfalseを指定してください。');
    }

    options = _.defaults(options || {}, _.clone(Transition.options));

    if (!_.isUndefined(options.data)) {
        this.set(options.data);
    }

    this.save();

    if (!_.isUndefined(options.props)) {
        this.setProp(options.props);
    }

    if (!_.isUndefined(options.methods)) {
        this.setMethod(options.methods);
    }

    this.container = null;

    this.source = null;
    this.target = null;

    this.guard = options.guard;
    this.effect = options.effect;
    this.internal = options.internal;

    if (this.internal) {
        if (this._rawSource !== this._rawTarget) {
            logger.error('遷移元と遷移先は同じStateインスタンスを指定してください。');
        }
    }

    this.unlocked = options.unlocked;

    this._isExplicitEntry = false;
    this._exitViaExitPoint = false;

    this.setObserverType('container');
};

Transition.options = {
    guard: null,
    effect: null,
    internal: false,

    unlocked: false,
};

Transition.prototype = _.create(Elem.prototype, {
    constructor: Transition,

    _cname: 'Transition',

    test: function () {
        var result = false;
        try {
            if (
                !this.isActive() &&
                this.container.isActive() &&
                this.source.isActive() &&
                !this.target.isActive()
            ) {
                result = true;
            }
        } catch (e) {}

        return result;
    },

    trigger: function () {
        var params = _.toArray(arguments);

        if (this.isActive()) {
            logger.error('Transitionインスタンス"' + this._name + '"はすでにアクティブ化されています。');
        }

        if (!this.container.isActive()) {
            logger.error('Transitionインスタンス"' + this._name + '"のコンテナが非アクティブです。');

        } else if (!this.source.isActive()) {
            logger.error('遷移元' + this.source._cname + 'インスタンス"' + this.source._name + '"が非アクティブです。');

        } else if (this.target.isActive()) {
            logger.error('遷移先' + this.target._cname + 'インスタンス"' + this.target._name + '"がアクティブです。');
        }

        if (!_.isNull(this.guard)) {
            if (!this.guard.apply(this, params)) {
                logger.info('ガードが成立しませんでした。遷移は発生しません。');
                return;
            }
        }

        if (this.internal) {
            if (this.source === this.target) {
                this._async(function () {
                    logger.info('内部遷移を実行します。');

                    if (!_.isNull(this.effect)) {
                        this.effect.apply(this, params);
                    }
                });

                return;
            } else {
                logger.error('遷移元と遷移先は同じStateインスタンスを指定してください。');
            }
        }

        this._async(function () {
            var message = {
                priority: null,
                deepHistory: false,
            };

            this._entry();

            if (this._exitViaExitPoint) {
                this.source.notify('parent', 'exit');

            } else {
                this.notify('source', 'exit');
            }

            if (!_.isNull(this.effect)) {
                this.effect.apply(this, params);
            }

            message.deepHistory = !!util.findDeepHistoryPseudoState(this.container);

            if (this._isExplicitEntry) {
                message.priority = this.target;
                this.target.notify('parent', 'entry', message);

            } else {
                this.notify('target', 'entry', message);
            }

            this._exit();
        });
    },

    update: function (event) {
        var params = _.toArray(arguments).slice(1);

        switch (event) {
            case 'refresh':
                this._refresh.apply(this, params);
                break;
        }
    },

    _getParentState: function () {
        var result = null;
        if (!_.isNull(this.container) && !_.isNull(this.container.parent)) {
            result = this.container.parent;
        }

        return result;
    },

    _refresh: function (depth) {
        this._depth = depth;
        this.parent = this._getParentState();
        this.notify('children', 'refresh', depth);
    },
});

module.exports = Transition;

},{"./base-state":7,"./elem":8,"./logger":10,"./pseudo-states":15,"./states":17,"./util":20,"underscore":3}],20:[function(require,module,exports){
'use strict';

var _ = require('underscore');

var global = (function (fn) {
    return (fn('return this')());
}(Function));

var util = {
    global: global,

    isFalsy: _.negate(Boolean),

    eachElem: function (state, callback) {
        var i, j, l, m, region, subState, transit;

        callback(state);

        for (i = 0, l = state.children.length; i < l; i += 1) {
            region = state.children[i];
            callback(region);

            for (j = 0, m = region.children.transitions.length; j < m; j += 1) {
                transit = region.children.transitions[j];
                callback(transit);
            }

            for (j = 0, m = region.children.states.length; j < m; j += 1) {
                subState = region.children.states[j];
                this.eachElem(subState, callback);
            }
        }
    },

    findDeepHistoryPseudoState: function (region) {
        var container;

        if (region.hasHistory(true)) {
            return region._historyPseudo;
        }

        container = region._getUpperContainer();
        if (!_.isNull(container)) {
            return this.findDeepHistoryPseudoState(container);
        }
    },

    findFirstTransition: function (region, from) {
        var EntryPointPseudoState, transits;
        EntryPointPseudoState = require('./pseudo-states').EntryPointPseudoState;
        transits = region.children.transitions;

        if (_.isUndefined(from)) {
            from = region._initialPseudo;
        }

        return _.find(transits, function (transit) {
            return transit.source === from;
        });
    },

    findNextTransition: function (region, from, to) {
        var ExitPointPseudoState, transits;
        ExitPointPseudoState = require('./pseudo-states').ExitPointPseudoState;
        transits = region.children.transitions;

        return _.find(transits, function (transit) {
            if (!_.isUndefined(to)) {
                return transit.source === from && transit.target === to;

            } else if (from instanceof ExitPointPseudoState) {
                return transit.source === from;

            } else {
                return transit.source === from && transit.unlocked;
            }
        });
    },

    findState: function (region, targetState, depth) {
        var i, j, l, m, state, subRegion, result;

        depth = !_.isUndefined(depth) ? depth : Infinity;

        if (depth >= 0) {
            depth -= 1;

            for (i = 0, l = region.children.states.length; i < l; i += 1) {
                state = region.children.states[i];

                if (state === targetState) {
                    return state;
                }

                for (j = 0, m = state.children.length; j < m; j += 1) {
                    subRegion = state.children[j];
                    result = this.findState(subRegion, targetState, depth);
                    if (!_.isUndefined(result)) {
                        return result;
                    }
                }
            }
        }
    },

    findRelatedTransition: function (state) {
        var container, result;
        container = state.container;
        if (!_.isNull(container)) {
            result = _.find(container.children.transitions, function (transit) {
                return transit.isActive() && (transit.source === state || transit.target === state);
            });
        }

        return result;
    },
};

module.exports = util;

},{"./pseudo-states":15,"underscore":3}],"async-fsm":[function(require,module,exports){
/* Async-FSM.js
 * version 0.5.82
 *
 * Copyright (c) 2018 Masa (http://wiz-code.digick.jp)
 * LICENSE: MIT license
 */
'use strict';

var FSM, logger, State, FinalState, Machine, SubMachine, InitialPseudoState, HistoryPseudoState, TerminatePseudoState, ChoicePseudoState, EntryPointPseudoState, ExitPointPseudoState, Transition, Region, util;

logger = require('./logger');
State = require('./states').State;
FinalState = require('./states').FinalState;
Machine = require('./machines').Machine;
SubMachine = require('./machines').SubMachine;
InitialPseudoState = require('./pseudo-states').InitialPseudoState;
HistoryPseudoState = require('./pseudo-states').HistoryPseudoState;
TerminatePseudoState = require('./pseudo-states').TerminatePseudoState;
ChoicePseudoState = require('./pseudo-states').ChoicePseudoState;
EntryPointPseudoState = require('./pseudo-states').EntryPointPseudoState;
ExitPointPseudoState = require('./pseudo-states').ExitPointPseudoState;
Transition = require('./transition');
Region = require('./region');

util = require('./util');

FSM = {
    logger: logger,

    Machine: Machine,
    State: State,
    Transition: Transition,
    Region: Region,

    InitialPseudoState: InitialPseudoState,
    FinalState: FinalState,
    SubMachine: SubMachine,
    HistoryPseudoState: HistoryPseudoState,
    TerminatePseudoState: TerminatePseudoState,
    ChoicePseudoState: ChoicePseudoState,

    EntryPointPseudoState: EntryPointPseudoState,
    ExitPointPseudoState: ExitPointPseudoState,

    globalize: globalize,
};

function globalize() {
    var g = util.global;

    g.Machine = Machine;
    g.State = State;
    g.Transition = Transition;
    g.Region = Region;

    g.InitialPseudoState = InitialPseudoState;
    g.FinalState = FinalState;
    g.SubMachine = SubMachine;
    g.HistoryPseudoState = HistoryPseudoState;
    g.TerminatePseudoState = TerminatePseudoState;
    g.ChoicePseudoState = ChoicePseudoState;

    g.EntryPointPseudoState = EntryPointPseudoState;
    g.ExitPointPseudoState = ExitPointPseudoState;
}

module.exports = FSM;

},{"./logger":10,"./machines":11,"./pseudo-states":15,"./region":16,"./states":17,"./transition":19,"./util":20}]},{},[]);
